import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Announcement from '../components/announcement'
import Navbar from '../components/navbar'
import Flowambassador from '../components/flowambassador'
import Formula2b from '../components/formula2b'
import Frametitle from '../components/frametitle'
import Formula5k from '../components/formula5k'
import ROIButton from '../components/roi-button'
import ChaptersActive from '../components/chapters-active'
import Chapters from '../components/chapters'
import Flowambassador2 from '../components/flowambassador2'
import AmbassadorsbtnR from '../components/ambassadorsbtn-r'
import AmbassadorsbtnL from '../components/ambassadorsbtn-l'
import AmbassadorsbtnCap from '../components/ambassadorsbtn-cap'
import Flowambassador3 from '../components/flowambassador3'
import Footerambassadors from '../components/footerambassadors'
import './ambassadors.css'

const Ambassadors = (props) => {
  return (
    <div className="ambassadors-container100">
      <Helmet>
        <title>Ambassadors - @Romania NGO</title>
        <meta
          name="description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta property="og:title" content="Ambassadors - @Romania NGO" />
        <meta
          property="og:description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/262a7285-ee36-4827-90cf-bff2da51d3e3/e678668e-577d-45ce-9b60-b935d207ee1c?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/ambassadors"
        />
        <meta
          property="og:url"
          content="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/ambassadors"
        />
      </Helmet>
      <div className="ambassadors-thq-hero-elm">
        <div className="ambassadors-thq-nav-elm1">
          <div id="notifcation" className="ambassadors-thq-notification-elm">
            <Announcement rootClassName="announcementroot-class-name2"></Announcement>
          </div>
          <Navbar rootClassName="navbarroot-class-name"></Navbar>
        </div>
        <div className="ambassadors-thq-text-elm10 container_1600">
          <div className="ambassadors-thq-content-elm10">
            <div className="ambassadors-container101">
              <h1 className="ambassadors-thq-title-elm1">
                <span>Thank you</span>
                <br></br>
              </h1>
              <h1 className="ambassadors-thq-title-elm2">
                for everything you&apos;ve done for Romania
              </h1>
              <img
                alt="image"
                src="/brush1-1500h.png"
                className="ambassadors-image100"
              />
            </div>
            <div className="ambassadors-container102">
              <span className="ambassadors-thq-caption-elm10 one-liner">
                If you are willing to join our initiative to do more and
                contribute €5,000, together we’ll put Romania back on the map.
              </span>
              <span className="paragraph">
                Stay awhile and learn how we’re going to do it, how you can
                become an Ambassador and what you get as a reward.
              </span>
            </div>
            <div className="ambassadors-thq-buttons-elm">
              <span className="ambassadors-text1002 formula_button">
                I don&apos;t need convincing
              </span>
            </div>
          </div>
          <div className="ambassadors-thq-nav-elm2">
            <a href="#ambassador" className="ambassadors-link10">
              <div className="ambassadors-thq-ambassador-elm1">
                <div className="ambassadors-thq-active-elm10">
                  <div className="ambassadors-thq-content-elm11">
                    <img
                      alt="image"
                      src="/nav patterns/ambassadors.svg"
                      className="ambassadors-image101"
                    />
                    <div className="ambassadors-thq-text-elm11">
                      <div className="ambassadors-container103">
                        <span className="ambassadors-text1003">Chapter 01</span>
                        <div className="ambassadors-thq-divider-elm10"></div>
                        <span className="ambassadors-text1004">08</span>
                      </div>
                      <span className="ambassadors-text1005">
                        Ambassador Program
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#brand" className="ambassadors-link11">
              <div className="ambassadors-thq-brand-elm1">
                <div className="ambassadors-thq-active-elm11">
                  <div className="ambassadors-thq-content-elm12">
                    <img
                      alt="image"
                      src="/nav patterns/country%20brand.svg"
                      className="ambassadors-image102"
                    />
                    <div className="ambassadors-thq-text-elm12">
                      <div className="ambassadors-container104">
                        <span className="ambassadors-text1006">Chapter 02</span>
                        <div className="ambassadors-thq-divider-elm11"></div>
                        <span className="ambassadors-text1007">08</span>
                      </div>
                      <span className="ambassadors-text1008">
                        Country Brand
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#mhouse" className="ambassadors-link12">
              <div className="ambassadors-thq-m-house-elm1">
                <div className="ambassadors-thq-active-elm12">
                  <div className="ambassadors-thq-content-elm13">
                    <img
                      alt="image"
                      src="/nav patterns/media%20house.svg"
                      className="ambassadors-image103"
                    />
                    <div className="ambassadors-thq-text-elm13">
                      <div className="ambassadors-container105">
                        <span className="ambassadors-text1009">Chapter 03</span>
                        <div className="ambassadors-thq-divider-elm12"></div>
                        <span className="ambassadors-text1010">08</span>
                      </div>
                      <span className="ambassadors-text1011">Media House</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#mhub" className="ambassadors-link13">
              <div className="ambassadors-thq-m-hub-elm1">
                <div className="ambassadors-thq-active-elm13">
                  <div className="ambassadors-thq-content-elm14">
                    <img
                      alt="image"
                      src="/nav patterns/media%20hub.svg"
                      className="ambassadors-image104"
                    />
                    <div className="ambassadors-thq-text-elm14">
                      <div className="ambassadors-container106">
                        <span className="ambassadors-text1012">Chapter 04</span>
                        <div className="ambassadors-thq-divider-elm13"></div>
                        <span className="ambassadors-text1013">08</span>
                      </div>
                      <span className="ambassadors-text1014">Media Hub</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#platform" className="ambassadors-link14">
              <div className="ambassadors-thq-platform-elm1">
                <div className="ambassadors-thq-active-elm14">
                  <div className="ambassadors-thq-content-elm15">
                    <img
                      alt="image"
                      src="/nav patterns/platform.svg"
                      className="ambassadors-image105"
                    />
                    <div className="ambassadors-thq-text-elm15">
                      <div className="ambassadors-container107">
                        <span className="ambassadors-text1015">Chapter 05</span>
                        <div className="ambassadors-thq-divider-elm14"></div>
                        <span className="ambassadors-text1016">08</span>
                      </div>
                      <span className="ambassadors-text1017">The Platform</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#initiative" className="ambassadors-link15">
              <div className="ambassadors-thq-initiative-elm1">
                <div className="ambassadors-thq-active-elm15">
                  <div className="ambassadors-thq-content-elm16">
                    <img
                      alt="image"
                      src="/nav patterns/made%20in%20ro.svg"
                      className="ambassadors-image106"
                    />
                    <div className="ambassadors-thq-text-elm16">
                      <div className="ambassadors-container108">
                        <span className="ambassadors-text1018">Chapter 06</span>
                        <div className="ambassadors-thq-divider-elm15"></div>
                        <span className="ambassadors-text1019">08</span>
                      </div>
                      <span className="ambassadors-text1020">
                        Origin &amp; Heritage Initiative
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#consultancy" className="ambassadors-link16">
              <div className="ambassadors-thq-consultancy-elm1">
                <div className="ambassadors-thq-active-elm16">
                  <div className="ambassadors-thq-content-elm17">
                    <img
                      alt="image"
                      src="/nav patterns/consultancy.svg"
                      className="ambassadors-image107"
                    />
                    <div className="ambassadors-thq-text-elm17">
                      <div className="ambassadors-container109">
                        <span className="ambassadors-text1021">Chapter 07</span>
                        <div className="ambassadors-thq-divider-elm16"></div>
                        <span className="ambassadors-text1022">08</span>
                      </div>
                      <span className="ambassadors-text1023">
                        Consultancy Service
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#education" className="ambassadors-link17">
              <div className="ambassadors-thq-education-elm1">
                <div className="ambassadors-thq-active-elm17">
                  <div className="ambassadors-thq-content-elm18">
                    <img
                      alt="image"
                      src="/nav patterns/education.svg"
                      className="ambassadors-image108"
                    />
                    <div className="ambassadors-thq-text-elm18">
                      <div className="ambassadors-container110">
                        <span className="ambassadors-text1024">Chapter 08</span>
                        <div className="ambassadors-thq-divider-elm17"></div>
                        <span className="ambassadors-text1025">08</span>
                      </div>
                      <span className="ambassadors-text1026">
                        Education Program
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div className="ambassadors-thq-text-elm19 container_1600">
          <Flowambassador rootClassName="flowambassadorroot-class-name"></Flowambassador>
          <div className="ambassadors-thq-nav-elm3">
            <a href="#ambassador" className="ambassadors-link18">
              <div className="ambassadors-thq-ambassador-elm2">
                <div className="ambassadors-thq-active-elm18">
                  <div className="ambassadors-thq-content-elm19">
                    <img
                      alt="image"
                      src="/nav patterns/ambassadors.svg"
                      className="ambassadors-image109"
                    />
                    <div className="ambassadors-thq-text-elm20">
                      <div className="ambassadors-container111">
                        <span className="ambassadors-text1027">Chapter 01</span>
                        <div className="ambassadors-thq-divider-elm18"></div>
                        <span className="ambassadors-text1028">08</span>
                      </div>
                      <span className="ambassadors-text1029">
                        Ambassador Program
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#brand" className="ambassadors-link19">
              <div className="ambassadors-thq-brand-elm2">
                <div className="ambassadors-thq-active-elm19">
                  <div className="ambassadors-thq-content-elm20">
                    <img
                      alt="image"
                      src="/nav patterns/country%20brand.svg"
                      className="ambassadors-image110"
                    />
                    <div className="ambassadors-thq-text-elm21">
                      <div className="ambassadors-container112">
                        <span className="ambassadors-text1030">Chapter 02</span>
                        <div className="ambassadors-thq-divider-elm19"></div>
                        <span className="ambassadors-text1031">08</span>
                      </div>
                      <span className="ambassadors-text1032">
                        Country Brand
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#mhouse" className="ambassadors-link20">
              <div className="ambassadors-thq-m-house-elm2">
                <div className="ambassadors-thq-active-elm20">
                  <div className="ambassadors-thq-content-elm21">
                    <img
                      alt="image"
                      src="/nav patterns/media%20house.svg"
                      className="ambassadors-image111"
                    />
                    <div className="ambassadors-thq-text-elm22">
                      <div className="ambassadors-container113">
                        <span className="ambassadors-text1033">Chapter 03</span>
                        <div className="ambassadors-thq-divider-elm20"></div>
                        <span className="ambassadors-text1034">08</span>
                      </div>
                      <span className="ambassadors-text1035">Media House</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#mhub" className="ambassadors-link21">
              <div className="ambassadors-thq-m-hub-elm2">
                <div className="ambassadors-thq-active-elm21">
                  <div className="ambassadors-thq-content-elm22">
                    <img
                      alt="image"
                      src="/nav patterns/media%20hub.svg"
                      className="ambassadors-image112"
                    />
                    <div className="ambassadors-thq-text-elm23">
                      <div className="ambassadors-container114">
                        <span className="ambassadors-text1036">Chapter 04</span>
                        <div className="ambassadors-thq-divider-elm21"></div>
                        <span className="ambassadors-text1037">08</span>
                      </div>
                      <span className="ambassadors-text1038">Media Hub</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#platform" className="ambassadors-link22">
              <div className="ambassadors-thq-platform-elm2">
                <div className="ambassadors-thq-active-elm22">
                  <div className="ambassadors-thq-content-elm23">
                    <img
                      alt="image"
                      src="/nav patterns/platform.svg"
                      className="ambassadors-image113"
                    />
                    <div className="ambassadors-thq-text-elm24">
                      <div className="ambassadors-container115">
                        <span className="ambassadors-text1039">Chapter 05</span>
                        <div className="ambassadors-thq-divider-elm22"></div>
                        <span className="ambassadors-text1040">08</span>
                      </div>
                      <span className="ambassadors-text1041">The Platform</span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#initiative" className="ambassadors-link23">
              <div className="ambassadors-thq-initiative-elm2">
                <div className="ambassadors-thq-active-elm23">
                  <div className="ambassadors-thq-content-elm24">
                    <img
                      alt="image"
                      src="/nav patterns/made%20in%20ro.svg"
                      className="ambassadors-image114"
                    />
                    <div className="ambassadors-thq-text-elm25">
                      <div className="ambassadors-container116">
                        <span className="ambassadors-text1042">Chapter 06</span>
                        <div className="ambassadors-thq-divider-elm23"></div>
                        <span className="ambassadors-text1043">08</span>
                      </div>
                      <span className="ambassadors-text1044">
                        Origin &amp; Heritage Initiative
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#consultancy" className="ambassadors-link24">
              <div className="ambassadors-thq-consultancy-elm2">
                <div className="ambassadors-thq-active-elm24">
                  <div className="ambassadors-thq-content-elm25">
                    <img
                      alt="image"
                      src="/nav patterns/consultancy.svg"
                      className="ambassadors-image115"
                    />
                    <div className="ambassadors-thq-text-elm26">
                      <div className="ambassadors-container117">
                        <span className="ambassadors-text1045">Chapter 07</span>
                        <div className="ambassadors-thq-divider-elm24"></div>
                        <span className="ambassadors-text1046">08</span>
                      </div>
                      <span className="ambassadors-text1047">
                        Consultancy Service
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
            <a href="#education" className="ambassadors-link25">
              <div className="ambassadors-thq-education-elm2">
                <div className="ambassadors-thq-active-elm25">
                  <div className="ambassadors-thq-content-elm26">
                    <img
                      alt="image"
                      src="/nav patterns/education.svg"
                      className="ambassadors-image116"
                    />
                    <div className="ambassadors-thq-text-elm27">
                      <div className="ambassadors-container118">
                        <span className="ambassadors-text1048">Chapter 08</span>
                        <div className="ambassadors-thq-divider-elm25"></div>
                        <span className="ambassadors-text1049">08</span>
                      </div>
                      <span className="ambassadors-text1050">
                        Education Program
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <img alt="image" src="/map.svg" className="ambassadors-thq-map-elm" />
        <img
          alt="image"
          src="/compressed-7100w.gif"
          className="ambassadors-thq-gif-elm"
        />
      </div>
      <div className="ambassadors-thq-divider-elm26"></div>
      <div id="intro" className="ambassadors-thq-intro-elm10 container_1600">
        <div className="ambassadors-thq-intro-elm11 chapter_left">
          <div className="ambassadors-container119">
            <div className="ambassadors-container120">
              <span className="index_black">Introduction</span>
              <div className="ambassadors-container121"></div>
              <span className="index_black">What is @Romania?</span>
            </div>
            <h2 className="heading">
              <span>
                Probably the most influential tourism brand in the country
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
          </div>
          <div className="ambassadors-thq-selector-elm">
            <p className="paragraph">
              <span>
                We&apos;re an NGO based in Bucharest and we&apos;ve been
                actively promoting Romania since 2019, with very limited
                resources and no government or corporate support. Despite this,
                we’ve managed to grow a massive audience of millions of people
                who tune in to see places in Romania that are worth visiting,
                many of whom we’ve converted into tourists for our country.
              </span>
              <br></br>
              <br></br>
              <span>
                Now we&apos;re ready to take things to the next level.
              </span>
              <br></br>
              <br></br>
              <span>
                Our mission is to build a Country Brand that will elevate
                Romania on the global stage, attract millions of tourists and
                improve the lives of everyone who calls our beautiful country
                home. To achieve this, we’ve developed a comprehensive strategy
                that includes the Ambassador Program which rewards contributors
                who share our vision, the Media house which acts as an
                independent creation engine, a dedicated Platform for travel and
                tourism promotion and 5 more exciting components detailed
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <a href="#ambassador" className="ambassadors-link26">
                here.
              </a>
              <br></br>
              <br></br>
              <span>
                If our words resonated with you so far, we’re positive you will
                enjoy reading the rest as much as we’ve enjoyed writing it. We
                recognize that time is a valuable resource and so we thank you
                for sharing yours with us; we promise not to waste it by
                sharing, in return, equally valuable knowledge.
              </span>
              <br></br>
              <br></br>
              <span>
                So please stay awhile and learn how far we’ve come with very
                limited resources, the importance of becoming an Ambassador and
                what more we will achieve with your support.
              </span>
            </p>
          </div>
        </div>
      </div>
      <section id="stats" className="ambassadors-thq-stats-elm container_1600">
        <div className="ambassadors-thq-header-elm10 chapter_left">
          <div className="ambassadors-container122">
            <div className="ambassadors-container123">
              <span className="index_black">
                @Romania
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <div className="ambassadors-container124"></div>
              <span className="index_black">Social Media Stats</span>
            </div>
            <h2 className="heading">
              <span>Here&apos;s what we&apos;ve done so far</span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
          </div>
          <p className="paragraph">
            <span>
              As a fully bootstrapped NGO, our focus for the past four years has
              been organic growth. Against all odds, we’ve achieved impressive
              results across top social platforms, especially when compared to
              highly funded organizations in the same space. With a Country
              Brand and a real budget, we could’ve done more.
            </span>
            <br></br>
          </p>
        </div>
        <Formula2b rootClassName="formula2broot-class-name"></Formula2b>
        <div className="ambassadors-thq-formula-elm1">
          <div className="ambassadors-thq-container-elm1">
            <span className="formula_blue">2B views generated</span>
            <div className="ambassadors-container125">
              <span className="formula_text">since 2019</span>
              <span className="formula_paragraph">
                with content aimed at promoting Romania
              </span>
            </div>
          </div>
          <img
            alt="image"
            src="/formula/arrow_black.svg"
            className="formula_arrow"
          />
          <div className="ambassadors-thq-container-elm2">
            <span className="formula_blue">
              1 in 10,000 viewers has visited Romania
            </span>
            <div className="ambassadors-container126">
              <span className="formula_text">button</span>
            </div>
          </div>
          <img
            alt="image"
            src="/formula/arrow_black.svg"
            className="formula_arrow"
          />
          <div className="ambassadors-container127">
            <span className="formula_blue">
              we&apos;ve brought 200K tourists
            </span>
            <div className="ambassadors-container128">
              <span className="formula_text">that&apos;s 50k per year</span>
              <span className="formula_paragraph">
                with no government or corporate support
              </span>
            </div>
          </div>
          <img alt="image" src="/formula/x_black.svg" className="formula_x" />
          <div className="ambassadors-container129">
            <span className="formula_blue">multiplied by €550 per tourist</span>
            <div className="ambassadors-container130">
              <span className="formula_text">
                average tourist spend
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="formula_paragraph">
                according to the Ministry of Economy, Entrepreneurship and
                Tourism
              </span>
            </div>
            <span className="ambassadors-text1087 paragraph">
              according to the Ministry of Economy, Entrepreneurship and Tourism
            </span>
          </div>
          <img
            alt="image"
            src="/formula/arrow_black.svg"
            className="formula_arrow"
          />
          <div className="ambassadors-container131">
            <span className="formula_blue">
              <span>that&apos;s more than </span>
              <span>€100M</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </span>
            <div className="ambassadors-container132">
              <span className="formula_text">to the economy</span>
              <span className="formula_paragraph">
                foreign money brought and spent in Romania as a result
              </span>
            </div>
          </div>
        </div>
        <div className="ambassadors-container133">
          <h2 className="ambassadors-thq-heading-elm12 paragraph">
            As a non-profit organization, we&apos;ve managed to empower
            Romania&apos;s tourism. The revenue generated as a result of our
            efforts has helped Romanian entrepreneurs and businesses within the
            realm of tourism and hospitality. With the largest part of that
            revenue going to the government as tax, ironically, a lot of it
            should have been used for Romania’s tourism promotion.
          </h2>
        </div>
        <div className="ambassadors-container134">
          <h2 className="ambassadors-thq-heading-elm13 one-liner">
            <span className="ambassadors-text1094">
              Today, even without a budget,
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span className="ambassadors-text1095">
              we’re growing faster than any other entity in the same space
            </span>
          </h2>
          <div className="ambassadors-container135">
            <a
              href="https://www.instagram.com/romania/"
              target="_blank"
              rel="noreferrer noopener"
              className="ambassadors-link27"
            >
              <div className="ambassadors-container136 formula_button">
                <img
                  alt="image"
                  src="/frames/ig_blue1.svg"
                  className="ambassadors-image119"
                />
                <span className="ambassadors-text1096">
                  instagram.com/romania
                </span>
                <img
                  alt="image"
                  src="/frames/corner_arrow.svg"
                  className="ambassadors-image120"
                />
              </div>
            </a>
            <div className="ambassadors-container137">
              <div className="ambassadors-container138">
                <div className="ambassadors-container139">
                  <span className="ambassadors-text1097 frame_numbers">
                    2023
                  </span>
                  <img
                    alt="image"
                    src="/formula/roi_blue2.svg"
                    className="ambassadors-image121"
                  />
                </div>
                <div className="ambassadors-container140">
                  <div className="ambassadors-container141">
                    <span className="ambassadors-text1098">650K-</span>
                    <span className="frame_numbers">700K</span>
                    <img
                      alt="image"
                      src="/frames/arrow.svg"
                      className="frame_arrow"
                    />
                  </div>
                  <span className="frame_text">followers</span>
                </div>
                <div className="ambassadors-container142">
                  <div className="ambassadors-container143">
                    <span className="ambassadors-text1101">650K-</span>
                    <span className="frame_numbers">20M+</span>
                    <img
                      alt="image"
                      src="/frames/arrow.svg"
                      className="frame_arrow"
                    />
                  </div>
                  <span className="frame_text">people reached per month</span>
                </div>
                <div className="ambassadors-container144">
                  <div className="ambassadors-container145">
                    <span className="ambassadors-text1104">650K-</span>
                    <span className="frame_numbers">60M+</span>
                    <img
                      alt="image"
                      src="/frames/arrow.svg"
                      className="frame_arrow"
                    />
                  </div>
                  <span className="frame_text">views per month</span>
                </div>
              </div>
              <div className="ambassadors-thq-divider-elm27">
                <div className="ambassadors-container146">
                  <img
                    alt="image"
                    src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                    className="ambassadors-image125"
                  />
                </div>
                <div className="ambassadors-container147">
                  <img
                    alt="image"
                    src="/formula/roi_green.svg"
                    className="ambassadors-image126"
                  />
                </div>
                <div className="ambassadors-container148">
                  <img
                    alt="image"
                    src="/formula/roi_green.svg"
                    className="ambassadors-image127"
                  />
                </div>
                <div className="ambassadors-container149">
                  <img
                    alt="image"
                    src="/formula/roi_green.svg"
                    className="ambassadors-image128"
                  />
                </div>
              </div>
              <div className="ambassadors-thq-container-elm3">
                <div className="ambassadors-container150">
                  <span className="ambassadors-text1107 frame_numbers">
                    2022
                  </span>
                  <img
                    alt="image"
                    src="/formula/roi_purple.svg"
                    className="ambassadors-image129"
                  />
                </div>
                <div className="ambassadors-thq-container-elm4">
                  <span className="ambassadors-text1108 frame_numbers">
                    200K
                  </span>
                  <span className="frame_text">followers</span>
                </div>
                <div className="ambassadors-thq-container-elm5">
                  <span className="ambassadors-text1110 frame_numbers">
                    500K+
                  </span>
                  <span className="frame_text">people reached per month</span>
                </div>
                <div className="ambassadors-thq-container-elm6">
                  <span className="ambassadors-text1112 frame_numbers">
                    1M+
                  </span>
                  <span className="frame_text">views per month</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ambassadors-thq-social-media-elm1">
          <div className="ambassadors-thq-accounts-elm1">
            <div className="card social">
              <div className="front frame">
                <Frametitle
                  image="/frames/ig_blue1.svg"
                  rootClassName="frametitleroot-class-name"
                ></Frametitle>
                <div className="ambassadors-container151">
                  <div className="ambassadors-thq-icon-elm">
                    <svg viewBox="0 0 1024 1024" className="ambassadors-icon10">
                      <path d="M512 92.2c136.8 0 153 0.6 206.8 3 50 2.2 77 10.6 95 17.6 23.8 9.2 41 20.4 58.8 38.2 18 18 29 35 38.4 58.8 7 18 15.4 45.2 17.6 95 2.4 54 3 70.2 3 206.8s-0.6 153-3 206.8c-2.2 50-10.6 77-17.6 95-9.2 23.8-20.4 41-38.2 58.8-18 18-35 29-58.8 38.4-18 7-45.2 15.4-95 17.6-54 2.4-70.2 3-206.8 3s-153-0.6-206.8-3c-50-2.2-77-10.6-95-17.6-23.8-9.2-41-20.4-58.8-38.2-18-18-29-35-38.4-58.8-7-18-15.4-45.2-17.6-95-2.4-54-3-70.2-3-206.8s0.6-153 3-206.8c2.2-50 10.6-77 17.6-95 9.2-23.8 20.4-41 38.2-58.8 18-18 35-29 58.8-38.4 18-7 45.2-15.4 95-17.6 53.8-2.4 70-3 206.8-3zM512 0c-139 0-156.4 0.6-211 3-54.4 2.4-91.8 11.2-124.2 23.8-33.8 13.2-62.4 30.6-90.8 59.2-28.6 28.4-46 57-59.2 90.6-12.6 32.6-21.4 69.8-23.8 124.2-2.4 54.8-3 72.2-3 211.2s0.6 156.4 3 211c2.4 54.4 11.2 91.8 23.8 124.2 13.2 33.8 30.6 62.4 59.2 90.8 28.4 28.4 57 46 90.6 59 32.6 12.6 69.8 21.4 124.2 23.8 54.6 2.4 72 3 211 3s156.4-0.6 211-3c54.4-2.4 91.8-11.2 124.2-23.8 33.6-13 62.2-30.6 90.6-59s46-57 59-90.6c12.6-32.6 21.4-69.8 23.8-124.2 2.4-54.6 3-72 3-211s-0.6-156.4-3-211c-2.4-54.4-11.2-91.8-23.8-124.2-12.6-34-30-62.6-58.6-91-28.4-28.4-57-46-90.6-59-32.6-12.6-69.8-21.4-124.2-23.8-54.8-2.6-72.2-3.2-211.2-3.2v0z"></path>
                      <path d="M512 249c-145.2 0-263 117.8-263 263s117.8 263 263 263 263-117.8 263-263c0-145.2-117.8-263-263-263zM512 682.6c-94.2 0-170.6-76.4-170.6-170.6s76.4-170.6 170.6-170.6c94.2 0 170.6 76.4 170.6 170.6s-76.4 170.6-170.6 170.6z"></path>
                      <path d="M846.8 238.6c0 33.91-27.49 61.4-61.4 61.4s-61.4-27.49-61.4-61.4c0-33.91 27.49-61.4 61.4-61.4s61.4 27.49 61.4 61.4z"></path>
                    </svg>
                  </div>
                  <span className="ambassadors-text1114 frame_title">
                    instagram
                  </span>
                </div>
                <span className="frame_goals_text">2025 goals-&gt;</span>
                <div className="ambassadors-container152">
                  <div className="ambassadors-thq-switch-elm10">
                    <span className="ambassadors-text1116">now</span>
                    <span className="ambassadors-text1117">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container153">
                    <span className="frame_numbers">700K</span>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container154">
                    <span className="frame_numbers">20M</span>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container155">
                    <span className="frame_numbers">TOP 75K</span>
                    <span className="frame_text">accounts on instagram</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm28">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
              <div className="back frame">
                <div className="ambassadors-container156">
                  <img
                    alt="image"
                    src="/frames/trophy_blue.svg"
                    className="ambassadors-image130"
                  />
                  <span className="frame_title">
                    <span>
                      Goals
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="ambassadors-text1126">for</span>
                    <span> 2025</span>
                  </span>
                </div>
                <div className="ambassadors-container157">
                  <div className="ambassadors-thq-switch-elm11">
                    <span className="ambassadors-text1128">now</span>
                    <span className="ambassadors-text1129">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container158">
                    <div className="ambassadors-container159">
                      <span className="ambassadors-text1130">650K-</span>
                      <span className="frame_numbers">3M</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container160">
                    <div className="ambassadors-container161">
                      <span className="frame_numbers">200M</span>
                      <span className="ambassadors-text1134">10M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container162">
                    <div className="ambassadors-container163">
                      <span className="frame_numbers">TOP 10K</span>
                      <span className="ambassadors-text1137">120M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">accounts on instagram</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm29">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
            </div>
            <img
              alt="image"
              src="/frames/divider.svg"
              className="frame_spacer"
            />
            <div className="card social">
              <div className="front frame">
                <span className="frame_goals_text">2025 goals-&gt;</span>
                <Frametitle
                  name="facebook.com/romania"
                  image="/frames/fb_blue.svg"
                  rootClassName="frametitleroot-class-name1"
                ></Frametitle>
                <div className="ambassadors-container164">
                  <div className="ambassadors-thq-switch-elm12">
                    <span className="ambassadors-text1140">now</span>
                    <span className="ambassadors-text1141">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container165">
                    <span className="frame_numbers">60K</span>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container166">
                    <span className="frame_numbers">1M</span>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container167">
                    <span className="frame_numbers">TOP 250K</span>
                    <span className="frame_text">pages on facebook</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm30">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
              <div className="back frame">
                <div className="ambassadors-container168">
                  <img
                    alt="image"
                    src="/frames/trophy_blue.svg"
                    className="ambassadors-image135"
                  />
                  <span className="frame_title">
                    <span>
                      goals
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="ambassadors-text1150">for</span>
                    <span> 2025</span>
                  </span>
                </div>
                <div className="ambassadors-container169">
                  <div className="ambassadors-thq-switch-elm13">
                    <span className="ambassadors-text1152">now</span>
                    <span className="ambassadors-text1153">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container170">
                    <div className="ambassadors-container171">
                      <span className="ambassadors-text1154">650K-</span>
                      <span className="frame_numbers">2M</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container172">
                    <div className="ambassadors-container173">
                      <span className="frame_numbers">100M</span>
                      <span className="ambassadors-text1158">10M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container174">
                    <div className="ambassadors-container175">
                      <span className="frame_numbers">TOP 20K</span>
                      <span className="ambassadors-text1161">120M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">pages on facebook</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm31">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
            </div>
            <img
              alt="image"
              src="/frames/divider.svg"
              className="frame_spacer"
            />
            <div className="card social ambassadors-thq-tiktok-elm">
              <div className="front frame">
                <span className="frame_goals_text">2025 goals-&gt;</span>
                <Frametitle
                  name="tiktok.com/@romania"
                  image="/frames/tt_blue.svg"
                  rootClassName="frametitleroot-class-name2"
                ></Frametitle>
                <div className="ambassadors-container176">
                  <div className="ambassadors-thq-switch-elm14">
                    <span className="ambassadors-text1164">now</span>
                    <span className="ambassadors-text1165">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container177">
                    <span className="frame_numbers">1.4M</span>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container178">
                    <span className="frame_numbers">50M</span>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container179">
                    <span className="frame_numbers">TOP 35K</span>
                    <span className="frame_text">accounts on tiktok</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm32">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
              <div className="back frame">
                <div className="ambassadors-container180">
                  <img
                    alt="image"
                    src="/frames/trophy_blue.svg"
                    className="ambassadors-image140"
                  />
                  <span className="frame_title">
                    <span>
                      goals
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="ambassadors-text1174">for</span>
                    <span> 2025</span>
                  </span>
                </div>
                <div className="ambassadors-container181">
                  <div className="ambassadors-thq-switch-elm15">
                    <span className="ambassadors-text1176">now</span>
                    <span className="ambassadors-text1177">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container182">
                    <div className="ambassadors-container183">
                      <span className="ambassadors-text1178">650K-</span>
                      <span className="frame_numbers">10M</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container184">
                    <div className="ambassadors-container185">
                      <span className="frame_numbers">400M</span>
                      <span className="ambassadors-text1182">10M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container186">
                    <div className="ambassadors-container187">
                      <span className="frame_numbers">TOP 5K</span>
                      <span className="ambassadors-text1185">120M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">accounts on tiktok</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm33">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="image"
            src="/frames/frame_shape1.svg"
            className="ambassadors-image144"
          />
          <img
            alt="image"
            src="/frames/frame_shape4.svg"
            className="ambassadors-image145"
          />
          <img
            alt="image"
            src="/frames/frame_shape6.svg"
            className="ambassadors-thq-image-elm3"
          />
          <img
            alt="image"
            src="/frames/frame_shape2.svg"
            className="ambassadors-thq-image-elm4"
          />
          <div className="ambassadors-container188">
            <div className="ambassadors-container189">
              <Script
                html={`<div class="card">
  <div class="front"></div>
  <div class="back"></div>
</div>


<style>

.card {
  position: relative;
  transition: all .5s ease-in-out;
  overflow: hidden;
}

.front {
  position: absolute;
  transition: transform .25s ease-out;
}

.back {
  position: absolute;
  transform: translateY(200%);
  transition: transform .25s ease-in, opacity .3s ease-in;
  opacity: 0;
}

/*Hovers*/

.card:hover .front {
  transform: translateY(100%);
}

.card:hover .back {
  transform: translateY(0);
  opacity: 1;
}

</style>
`}
              ></Script>
            </div>
          </div>
        </div>
        <div className="ambassadors-thq-formula-elm2">
          <div className="ambassadors-container190">
            <span className="formula_blue">120M views per month</span>
            <div className="ambassadors-container191">
              <span className="formula_text">on average</span>
              <span className="formula_paragraph">
                that&apos;s views currently being generated across all platforms
              </span>
            </div>
          </div>
          <img alt="image" src="/formula/x_black.svg" className="formula_x" />
          <div className="ambassadors-container192">
            <span className="formula_blue">multiplied by €8.3</span>
            <div className="ambassadors-container193">
              <span className="formula_text">average CPM</span>
              <span className="formula_paragraph">
                {' '}
                cost for tourism advertisement on social media
              </span>
            </div>
            <span className="ambassadors-text1193 paragraph">
              according to the Ministry of Economy, Entrepreneurship and Tourism
            </span>
          </div>
          <img
            alt="image"
            src="/formula/arrow_black.svg"
            className="formula_arrow"
          />
          <div className="ambassadors-container194">
            <span className="ambassadors-text1194 formula_blue">
              <span>that&apos;s </span>
              <span>€1M per month</span>
            </span>
            <div className="ambassadors-container195">
              <span className="formula_text">in promotion value</span>
              <span className="formula_paragraph">
                that&apos;s how much it costs to generate this level of exposure
                on social media
              </span>
            </div>
          </div>
        </div>
        <div className="ambassadors-container196">
          <h2 className="ambassadors-thq-heading-elm14 one-liner">
            <span className="ambassadors-text1199">
              Next,
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span className="ambassadors-text1200">
              with your support and a dedicated budget
            </span>
            <span className="ambassadors-text1201">
              {' '}
              we can expand to other platforms
            </span>
            <br className="ambassadors-text1202"></br>
            <span className="ambassadors-text1203">
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </h2>
        </div>
        <div className="ambassadors-thq-social-media-elm2">
          <div className="ambassadors-thq-accounts-elm2">
            <div className="card social">
              <div className="front ambassadors-thq-front-elm4 frame">
                <Frametitle
                  name="youtube.com"
                  image="/frames/yt_blue.svg"
                  rootClassName="frametitleroot-class-name4"
                ></Frametitle>
                <div className="ambassadors-container197">
                  <div className="ambassadors-thq-switch-elm16">
                    <span className="ambassadors-text1204">now</span>
                    <span className="ambassadors-text1205">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container198">
                    <span className="frame_numbers">0</span>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container199">
                    <span className="frame_numbers">0</span>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container200">
                    <span className="frame_numbers">TOP 0</span>
                    <span className="frame_text">channels on youtube</span>
                  </div>
                  <span className="ambassadors-text1212 frame_text">
                    <span>
                      We have several game-changing formulas to achieve success
                      on YouTube.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      With your help, we can execute our vision and produce
                      truly original content, revealing Romania’s full potential
                      as an international travel destination.
                    </span>
                  </span>
                </div>
                <div className="ambassadors-thq-divider-elm34">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
                <span className="frame_goals_text">2025 goals-&gt;</span>
              </div>
              <div className="back frame">
                <div className="ambassadors-container201">
                  <img
                    alt="image"
                    src="/frames/trophy_blue.svg"
                    className="ambassadors-image148"
                  />
                  <span className="frame_title">
                    <span>
                      Goals
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="ambassadors-text1220">for</span>
                    <span> 2025</span>
                  </span>
                </div>
                <div className="ambassadors-container202">
                  <div className="ambassadors-thq-switch-elm17">
                    <span className="ambassadors-text1222">now</span>
                    <span className="ambassadors-text1223">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container203">
                    <div className="ambassadors-container204">
                      <span className="ambassadors-text1224">650K-</span>
                      <span className="frame_numbers">1M</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container205">
                    <div className="ambassadors-container206">
                      <span className="frame_numbers">200M</span>
                      <span className="ambassadors-text1228">10M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container207">
                    <div className="ambassadors-container208">
                      <span className="frame_numbers">TOP 10K</span>
                      <span className="ambassadors-text1231">120M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">channels on youtube</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm35">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
            </div>
            <img
              alt="image"
              src="/frames/divider.svg"
              className="frame_spacer"
            />
            <div className="card social">
              <div className="front ambassadors-thq-front-elm5 frame">
                <Frametitle
                  name="twitter.com"
                  image="/frames/x_blue.svg"
                  rootClassName="frametitleroot-class-name3"
                ></Frametitle>
                <div className="ambassadors-container209">
                  <div className="ambassadors-thq-switch-elm18">
                    <span className="ambassadors-text1233">now</span>
                    <span className="ambassadors-text1234">goals -&gt;</span>
                  </div>
                  <span className="ambassadors-thq-text-elm28 frame_text">
                    <span>
                      With your help, Romania will have an impactful voice on
                      one of the world’s largest conversation hubs.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      Having the right support means we can deploy our winning
                      communication strategy and build a dedicated team that can
                      create high-impact engagement and amplify Romania’s
                      message to the world.
                    </span>
                    <br></br>
                    <br></br>
                  </span>
                  <div className="ambassadors-container210"></div>
                  <div className="ambassadors-container211">
                    <span className="frame_numbers">0</span>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container212">
                    <span className="frame_numbers">TOP 0</span>
                    <span className="frame_text">accounts on twitter</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm36">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
                <span className="frame_goals_text">2025 goals-&gt;</span>
              </div>
              <div className="back frame">
                <div className="ambassadors-container213">
                  <img
                    alt="image"
                    src="/frames/trophy_blue.svg"
                    className="ambassadors-image153"
                  />
                  <span className="frame_title">
                    <span>
                      Goals
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="ambassadors-text1248">for</span>
                    <span> 2025</span>
                  </span>
                </div>
                <div className="ambassadors-container214">
                  <div className="ambassadors-thq-switch-elm19">
                    <span className="ambassadors-text1250">now</span>
                    <span className="ambassadors-text1251">goals -&gt;</span>
                  </div>
                  <div className="ambassadors-container215">
                    <div className="ambassadors-container216">
                      <span className="ambassadors-text1252">650K-</span>
                      <span className="frame_numbers">100K</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">followers</span>
                  </div>
                  <div className="ambassadors-container217">
                    <div className="ambassadors-container218">
                      <span className="frame_numbers">200M</span>
                      <span className="ambassadors-text1256">10M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">people reached per month</span>
                  </div>
                  <div className="ambassadors-container219">
                    <div className="ambassadors-container220">
                      <span className="frame_numbers">TOP 10K</span>
                      <span className="ambassadors-text1259">120M-</span>
                      <img
                        alt="image"
                        src="/frames/arrow.svg"
                        className="frame_arrow"
                      />
                    </div>
                    <span className="frame_text">accounts on twitter</span>
                  </div>
                </div>
                <div className="ambassadors-thq-divider-elm37">
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                  <div className="square_shape"></div>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="image"
            src="/frames/frame_shape1.svg"
            className="ambassadors-image157"
          />
          <img
            alt="image"
            src="/frames/frame_shape4.svg"
            className="ambassadors-image158"
          />
          <img
            alt="image"
            src="/frames/frame_shape6.svg"
            className="ambassadors-image159"
          />
          <img
            alt="image"
            src="/frames/frame_shape2.svg"
            className="ambassadors-thq-image-elm5"
          />
        </div>
      </section>
      <div id="strategy" className="ambassadors-thq-intro-elm12 container_1600">
        <div className="chapter_left">
          <div className="ambassadors-container221">
            <div className="ambassadors-container222">
              <span className="index_black">
                @Romania
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <div className="ambassadors-container223"></div>
              <span className="index_black">Strategy in 8 Chapters</span>
            </div>
            <h2 className="heading">
              <span>We&apos;re changing the game</span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
          </div>
          <p className="paragraph">
            <span>Why support @Romania instead of other non-profits?</span>
            <br></br>
            <br></br>
            <span>
              Because your €5,000 contribution to @Romania’s initiative has a
              reverberating positive impact on our country’s economy. This is
              more than a donation with a singular effect, it’s an economic
              multiplier with tangible return that extends beyond Romania’s
              tourism industry and boosts multiple sectors throughout our
              economy.
            </span>
            <br></br>
            <br></br>
            <span>
              With such extraordinary potential, can you really afford
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span className="ambassadors-text1273">not</span>
            <span> to help us?</span>
          </p>
        </div>
        <div className="ambassadors-thq-container-elm7">
          <div className="ambassadors-thq-formulaold-elm">
            <div className="ambassadors-thq-one-elm">
              <div className="ambassadors-container224">
                <span className="ambassadors-text1275">with</span>
                <div className="ambassadors-container225">
                  <span className="formula_eur2">€</span>
                  <span className="formula_numbers2">5,000</span>
                </div>
              </div>
              <div className="ambassadors-container226">
                <div className="ambassadors-thq-divider-elm38">
                  <div className="ambassadors-container227">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
                <img
                  alt="image"
                  src="/formula/shape1_blue.svg"
                  className="ambassadors-image160"
                />
                <div className="ambassadors-thq-divider-elm39">
                  <div className="ambassadors-container228">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-arrow-elm10">
              <div className="ambassadors-container229"></div>
              <div className="ambassadors-thq-arrow-elm11">
                <div className="ambassadors-thq-divider-elm40">
                  <div className="ambassadors-container230">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
                <div className="ambassadors-thq-arrow-elm12">
                  <img
                    alt="image"
                    src="/formula/shape3_b.svg"
                    className="ambassadors-image161"
                  />
                </div>
                <div className="ambassadors-thq-divider-elm41">
                  <div className="ambassadors-container231">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-two-elm">
              <div className="ambassadors-container232">
                <span className="ambassadors-text1278">we can reach</span>
                <div className="ambassadors-container233">
                  <span className="formula_numbers2">5</span>
                  <span className="ambassadors-text1280 formula_numbers">
                    million
                  </span>
                </div>
                <span className="ambassadors-text1281">people</span>
              </div>
              <div className="ambassadors-container234">
                <div className="ambassadors-container235">
                  <div className="ambassadors-thq-divider-elm42">
                    <div className="ambassadors-container236">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                  <img
                    alt="image"
                    src="/formula/shape1_blue.svg"
                    className="ambassadors-image162"
                  />
                  <div className="ambassadors-thq-divider-elm43">
                    <div className="ambassadors-container237">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                </div>
                <div className="ambassadors-container238">
                  <div className="ambassadors-thq-container-elm8">
                    <span className="ambassadors-text1282 formula_text1">
                      at €1 CPM
                    </span>
                  </div>
                  <div className="ambassadors-container239">
                    <span className="ambassadors-text1283 formula_text2">
                      don&apos;t worry if you don&apos;t exactly know what CPM
                      is, just trust us, it&apos;s a very efficient cost
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-container240">
              <div className="ambassadors-container241">
                <span className="ambassadors-text1284">
                  if 1 in every 1,000 people becomes a tourist
                </span>
              </div>
              <div className="ambassadors-container242">
                <div className="ambassadors-container243">
                  <div className="ambassadors-thq-divider-elm44">
                    <div className="ambassadors-container244">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                  <img
                    alt="image"
                    src="/formula/shape7_r.svg"
                    className="ambassadors-image163"
                  />
                  <div className="ambassadors-thq-divider-elm45">
                    <div className="ambassadors-container245">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-arrow-elm13">
              <div className="ambassadors-container246"></div>
              <div className="ambassadors-thq-arrow-elm14">
                <div className="ambassadors-thq-divider-elm46">
                  <div className="ambassadors-container247">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
                <div className="ambassadors-thq-arrow-elm15">
                  <img
                    alt="image"
                    src="/formula/shape3_b.svg"
                    className="ambassadors-image164"
                  />
                </div>
                <div className="ambassadors-thq-divider-elm47">
                  <div className="ambassadors-container248">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-three-elm">
              <div className="ambassadors-container249">
                <span className="ambassadors-text1285">you help bring</span>
                <div className="ambassadors-container250">
                  <span className="formula_numbers2">5,000</span>
                </div>
                <span className="ambassadors-text1287">
                  tourists to Romania
                </span>
              </div>
              <div className="ambassadors-container251">
                <div className="ambassadors-container252">
                  <div className="ambassadors-thq-divider-elm48">
                    <div className="ambassadors-container253">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                  <img
                    alt="image"
                    src="/formula/shape1_blue.svg"
                    className="ambassadors-image165"
                  />
                  <div className="ambassadors-thq-divider-elm49">
                    <div className="ambassadors-container254">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                </div>
                <div className="ambassadors-container255">
                  <div className="ambassadors-container256">
                    <span className="ambassadors-text1288 formula_text1">
                      at €1 cost per tourist
                    </span>
                  </div>
                  <div className="ambassadors-container257">
                    <span className="ambassadors-text1289 formula_text2">
                      currently, the average cost in Romania is €X per tourist
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-multiply-elm">
              <div className="ambassadors-container258"></div>
              <div className="ambassadors-thq-arrow-elm16">
                <div className="ambassadors-thq-divider-elm50">
                  <div className="ambassadors-container259">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
                <div className="ambassadors-thq-arrow-elm17">
                  <img
                    alt="image"
                    src="/formula/x_y.svg"
                    className="ambassadors-image166"
                  />
                </div>
                <div className="ambassadors-thq-divider-elm51">
                  <div className="ambassadors-container260">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-four-elm">
              <div className="ambassadors-container261">
                <span className="ambassadors-text1290">
                  if we multiply that by
                </span>
                <div className="ambassadors-container262">
                  <span className="formula_eur2">€</span>
                  <span className="formula_numbers2">550</span>
                </div>
                <span className="ambassadors-text1293">for each tourist</span>
              </div>
              <div className="ambassadors-container263">
                <div className="ambassadors-container264">
                  <div className="ambassadors-thq-divider-elm52">
                    <div className="ambassadors-container265">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                  <img
                    alt="image"
                    src="/formula/shape1_blue.svg"
                    className="ambassadors-image167"
                  />
                  <div className="ambassadors-thq-divider-elm53">
                    <div className="ambassadors-container266">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                </div>
                <div className="ambassadors-container267">
                  <div className="ambassadors-container268">
                    <span className="ambassadors-text1294 formula_text1">
                      this is how much a tourist spends on average in Romania
                    </span>
                  </div>
                  <div className="ambassadors-container269">
                    <span className="ambassadors-text1295 formula_text2">
                      according to the Ministry of Economy, Entrepreneurship and
                      Tourism
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-arrow-elm18">
              <div className="ambassadors-container270"></div>
              <div className="ambassadors-thq-arrow-elm19">
                <div className="ambassadors-thq-divider-elm54">
                  <div className="ambassadors-container271">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
                <div className="ambassadors-thq-arrow-elm20">
                  <img
                    alt="image"
                    src="/formula/shape3_b.svg"
                    className="ambassadors-image168"
                  />
                </div>
                <div className="ambassadors-thq-divider-elm55">
                  <div className="ambassadors-container272">
                    <div className="square_shape"></div>
                    <div className="square_shape"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ambassadors-thq-five-elm1">
              <div className="ambassadors-container273">
                <span className="ambassadors-text1296">that&apos;s</span>
                <div className="ambassadors-container274">
                  <span className="formula_eur2">€</span>
                  <span className="formula_numbers2">2.75</span>
                  <span className="ambassadors-text1299 formula_numbers">
                    million
                  </span>
                </div>
                <span className="ambassadors-text1300">
                  added to the economy
                </span>
              </div>
              <div className="ambassadors-container275">
                <div className="ambassadors-container276">
                  <div className="ambassadors-thq-divider-elm56">
                    <div className="ambassadors-container277">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                  <img
                    alt="image"
                    src="/formula/shape1_g.svg"
                    className="ambassadors-image169"
                  />
                  <div className="ambassadors-thq-divider-elm57">
                    <div className="ambassadors-container278">
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                      <div className="square_shape"></div>
                    </div>
                  </div>
                </div>
                <div className="ambassadors-container279">
                  <div className="ambassadors-container280">
                    <span className="ambassadors-text1301 formula_text1">
                      this is how much foreign money comes in and is spent in
                      Romania as a result
                    </span>
                  </div>
                  <div className="ambassadors-container281">
                    <span className="ambassadors-text1302 formula_text2">
                      54900% return on the initial €5,000
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ambassadors-thq-formula-elm3">
            <div className="ambassadors-container282">
              <div className="ambassadors-thq-five-elm2">
                <div className="ambassadors-container283">
                  <span className="frame_numbers">
                    <span>
                      your
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="ambassadors-text1305">€5,000</span>
                    <span> helps us reach 5M people</span>
                  </span>
                </div>
                <img
                  alt="image"
                  src="/formula/arrow_black.svg"
                  className="ambassadors-thq-image-elm6"
                />
              </div>
              <div className="ambassadors-container284">
                <div className="ambassadors-container285">
                  <span className="frame_numbers">if 1 in 1,000 people</span>
                  <span className="ambassadors-text1308">
                    becomes a tourist
                  </span>
                </div>
                <img
                  alt="image"
                  src="/formula/arrow_black.svg"
                  className="ambassadors-thq-image-elm7"
                />
                <div className="ambassadors-container286">
                  <span className="frame_numbers">we bring 5,000 tourists</span>
                  <span className="ambassadors-text1310">to Romania</span>
                </div>
                <img
                  alt="image"
                  src="/formula/x_black.svg"
                  className="ambassadors-image170"
                />
                <div className="ambassadors-container287">
                  <span className="frame_numbers">
                    multiplied by €550 per tourist
                  </span>
                  <span className="ambassadors-text1312">
                    average tourist spend
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="ambassadors-text1313 paragraph">
                    according to the Ministry of Economy, Entrepreneurship and
                    Tourism
                  </span>
                </div>
                <img
                  alt="image"
                  src="/formula/arrow_black.svg"
                  className="ambassadors-image171"
                />
                <div className="ambassadors-container288">
                  <span className="frame_numbers">
                    <span>
                      that&apos;s
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span>€2.75M</span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </span>
                  <span className="ambassadors-text1318">to the economy</span>
                  <span className="ambassadors-text1319">54,900% return</span>
                </div>
              </div>
            </div>
          </div>
          <div className="ambassadors-container289">
            <Formula5k></Formula5k>
          </div>
          <div className="ambassadors-container290">
            <div className="ambassadors-thq-examples-elm">
              <p className="ambassadors-thq-caption-elm15 one-liner">
                <span>
                  Here are some examples of recent successful tourism campaigns
                  from around the world:
                </span>
                <br></br>
              </p>
            </div>
            <div className="ambassadors-container291">
              <div className="ambassadors-container292">
                <a
                  href="https://www.michigan.org/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="ambassadors-link28"
                >
                  <div className="ambassadors-container293">
                    <p className="formula_text ambassadors-thq-caption-elm16">
                      1. &quot;Pure Michigan&quot; by MEDC
                    </p>
                    <svg viewBox="0 0 1024 1024" className="ambassadors-icon14">
                      <path d="M298.667 341.333h323.669l-353.835 353.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l353.835-353.835v323.669c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-426.667c0-5.803-1.152-11.307-3.243-16.341s-5.163-9.728-9.216-13.781c-0.043-0.043-0.043-0.043-0.085-0.085-3.925-3.925-8.619-7.083-13.781-9.216-5.035-2.091-10.539-3.243-16.341-3.243h-426.667c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
                    </svg>
                  </div>
                </a>
                <div className="ambassadors-container294">
                  <p className="paragraph">
                    <span className="ambassadors-text1322">Budget:</span>
                    <span> $17.5 million in 2022</span>
                    <br></br>
                  </p>
                  <p className="paragraph">
                    <span className="ambassadors-text1325">Generated:</span>
                    <span> $3.1 billion in 2022</span>
                    <br></br>
                  </p>
                </div>
                <div className="ambassadors-thq-roi-elm1">
                  <ROIButton></ROIButton>
                  <div className="ambassadors-container295">
                    <div className="ambassadors-container296">
                      <img
                        alt="image"
                        src="/formula/roi_black.svg"
                        className="ambassadors-image172"
                      />
                      <p className="ambassadors-thq-caption-elm19 formula_text">
                        <span>
                          $177 for every $1 spent
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <br></br>
                      </p>
                    </div>
                    <div className="ambassadors-container297">
                      <img
                        alt="image"
                        src="/formula/roi_blue2.svg"
                        className="ambassadors-image173"
                      />
                      <p className="ambassadors-thq-caption-elm20 formula_text">
                        17614% return
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ambassadors-container298">
                <a
                  href="https://www.newzealand.com/int/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="ambassadors-link29"
                >
                  <div className="ambassadors-container299">
                    <p className="formula_text ambassadors-thq-caption-elm21">
                      2. &quot;100% Pure New Zealand&quot; by TNZ
                    </p>
                    <svg viewBox="0 0 1024 1024" className="ambassadors-icon16">
                      <path d="M298.667 341.333h323.669l-353.835 353.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l353.835-353.835v323.669c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-426.667c0-5.803-1.152-11.307-3.243-16.341s-5.163-9.728-9.216-13.781c-0.043-0.043-0.043-0.043-0.085-0.085-3.925-3.925-8.619-7.083-13.781-9.216-5.035-2.091-10.539-3.243-16.341-3.243h-426.667c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
                    </svg>
                  </div>
                </a>
                <div className="ambassadors-container300">
                  <p className="paragraph">
                    <span className="ambassadors-text1330">Budget:</span>
                    <span> NZ$112 million in 2022</span>
                    <br></br>
                  </p>
                  <p className="paragraph">
                    <span className="ambassadors-text1333">Generated:</span>
                    <span> NZ$5 billion in 2022</span>
                    <br></br>
                  </p>
                </div>
                <div className="ambassadors-thq-roi-elm2">
                  <ROIButton rootClassName="roi-buttonroot-class-name2"></ROIButton>
                  <div className="ambassadors-container301">
                    <div className="ambassadors-container302">
                      <img
                        alt="image"
                        src="/formula/roi_black.svg"
                        className="ambassadors-image174"
                      />
                      <p className="ambassadors-thq-caption-elm24 formula_text">
                        <span>
                          NZ$44 for every NZ$1 spent
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <br></br>
                      </p>
                    </div>
                    <div className="ambassadors-container303">
                      <img
                        alt="image"
                        src="/formula/roi_blue2.svg"
                        className="ambassadors-image175"
                      />
                      <p className="ambassadors-thq-caption-elm25 formula_text">
                        4364% return
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ambassadors-container304">
                <a
                  href="https://www.michigan.org/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className="ambassadors-container305">
                    <p className="formula_text ambassadors-thq-caption-elm26">
                      3. &quot;Scotland is Now&quot; by VisitScotland
                    </p>
                    <svg viewBox="0 0 1024 1024" className="ambassadors-icon18">
                      <path d="M298.667 341.333h323.669l-353.835 353.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l353.835-353.835v323.669c0 23.552 19.115 42.667 42.667 42.667s42.667-19.115 42.667-42.667v-426.667c0-5.803-1.152-11.307-3.243-16.341s-5.163-9.728-9.216-13.781c-0.043-0.043-0.043-0.043-0.085-0.085-3.925-3.925-8.619-7.083-13.781-9.216-5.035-2.091-10.539-3.243-16.341-3.243h-426.667c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
                    </svg>
                  </div>
                </a>
                <div className="ambassadors-container306">
                  <p className="paragraph">
                    <span className="ambassadors-text1338">Budget:</span>
                    <span> £20 million in 2022</span>
                    <br></br>
                  </p>
                  <p className="paragraph">
                    <span className="ambassadors-text1341">Generated:</span>
                    <span> £104 million in 2022</span>
                    <br></br>
                  </p>
                </div>
                <div className="ambassadors-thq-roi-elm3">
                  <ROIButton rootClassName="roi-buttonroot-class-name3"></ROIButton>
                  <div className="ambassadors-container307">
                    <div className="ambassadors-container308">
                      <img
                        alt="image"
                        src="/formula/roi_black.svg"
                        className="ambassadors-image176"
                      />
                      <p className="ambassadors-thq-caption-elm29 formula_text">
                        <span>
                          £5 for every £1 spent
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                        <br></br>
                      </p>
                    </div>
                    <div className="ambassadors-container309">
                      <img
                        alt="image"
                        src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                        className="ambassadors-image177"
                      />
                      <p className="ambassadors-thq-caption-elm30 formula_text">
                        420% return
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ambassadors-container310">
            <h2 className="ambassadors-thq-heading-elm16 one-liner">
              <span className="ambassadors-text1346">
                With that being said,
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="ambassadors-text1347">not all €5,000</span>
              <span className="ambassadors-text1348">
                {' '}
                of your contribution will be spent on tourist conversion
              </span>
              <br className="ambassadors-text1349"></br>
              <span className="ambassadors-text1350">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
            <p className="paragraph">
              <span>
                We&apos;ve developed a comprehensive strategy for creating value
                for Romania&apos;s tourism promotion and for you as a valued
                supporter.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                Find out what you get as an Ambassador for @Romania and what our
                plans are moving forward, in the next chapters.
              </span>
              <br></br>
            </p>
          </div>
        </div>
      </div>
      <div id="ambassador" className="container_1600">
        <div className="nav">
          <ChaptersActive
            image="/nav patterns/ambassadors.svg"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name"
          ></ChaptersActive>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/country%20brand.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/country%20brand.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component24"
            ></Chapters>
          </a>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component25"
            ></Chapters>
          </a>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component26"
            ></Chapters>
          </a>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Platform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Platform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component27"
            ></Chapters>
          </a>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component28"
            ></Chapters>
          </a>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component29"
            ></Chapters>
          </a>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component30"
            ></Chapters>
          </a>
        </div>
        <Flowambassador2></Flowambassador2>
        <div id="inspire" className="ambassadors-container311">
          <section className="ambassadors-thq-inspire-elm ambassadors_section">
            <div className="ambassadors_imgboxL">
              <img
                alt="image"
                src="/assets/asset%2046.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2046.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2046.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2046.svg"
                className="ambassadors_img"
              />
            </div>
            <div className="ambassadors-thq-header-elm12 ambassadors_box">
              <div className="ambassadors-container312">
                <div className="ambassadors-thq-header-elm13">
                  <div className="ambassadors-container313">
                    <span className="index_blue">01</span>
                    <div className="ambassadors-container314"></div>
                    <span className="index_black">Certificate of merit</span>
                  </div>
                  <div className="ambassadors-container315">
                    <h2 className="ambassadors_word">Inspire</h2>
                    <h2 className="ambassadors-thq-heading-elm18 ambassadors_heading">
                      <span className="ambassadors-text1358">
                        positive change
                      </span>
                      <br></br>
                      <span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </h2>
                  </div>
                </div>
                <p className="ambassadors-thq-caption-elm32 ambassadors_text">
                  as an appointed Honorary Tourism Ambassador for @Romania, a
                  title inked alongside your name on an official certificate of
                  merit
                </p>
              </div>
              <p className="ambassadors-thq-caption-elm33 paragraph">
                <span className="ambassadors-text1361">R</span>
                <span className="ambassadors-text1362">each</span>
                <span>
                  {' '}
                  beyond excellence by claiming your place among the select few
                  Honorary Tourism Ambassadors, who are celebrated with a
                  prestigious framed certificate personally signed by the
                  President of @Romania. This is a group of elite,
                  forward-thinking innovators driven by the same honorable
                  motivations. To promote Romania’s cultural heritage, to
                  nurture sustainable tourism and to chart a course of
                  prosperity for our country and the people it represents
                </span>
              </p>
            </div>
            <a href="#embrace">
              <AmbassadorsbtnR
                imageSrc="/assets/asset%2044.svg"
                imageSrc1="/assets/asset%2044.svg"
                imageSrc11="/assets/asset%2044.svg"
                className="ambassadors-component32"
              ></AmbassadorsbtnR>
            </a>
          </section>
        </div>
        <div id="embrace" className="ambassadors-container316">
          <section className="ambassadors-thq-embrace-elm ambassadors_section">
            <a href="#mark">
              <AmbassadorsbtnL
                imageSrc="/assets/asset042zz.svg"
                imageSrc1="/assets/asset042zz.svg"
                imageSrc11="/assets/asset042zz.svg"
                rootClassName="ambassadorsbtn-lroot-class-name"
                className="ambassadors-component33"
              ></AmbassadorsbtnL>
            </a>
            <div className="ambassadors-thq-header-elm14 ambassadors_box">
              <div className="ambassadors-container317">
                <div className="ambassadors-thq-header-elm15">
                  <div className="ambassadors-container318">
                    <span className="index_blue">02</span>
                    <div className="ambassadors-container319"></div>
                    <span className="index_black">
                      Your name on the @Romania platform
                    </span>
                  </div>
                  <div className="ambassadors-container320">
                    <h2 className="ambassadors_word">Embrace</h2>
                    <h2 className="ambassadors-thq-heading-elm20 ambassadors_heading">
                      <span className="ambassadors-text1366">
                        everlasting recognition
                      </span>
                      <br></br>
                      <span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </h2>
                  </div>
                </div>
                <p className="ambassadors-thq-caption-elm34 ambassadors_text">
                  by having your name forever honored on @Romania’s platform, as
                  we build the Country’s Brand for the future
                </p>
              </div>
              <p className="ambassadors-thq-caption-elm35 paragraph">
                <span>Revel in the glow of acclaim with your name </span>
                <span>
                  permanently embedded on @Romania’s website alongside pioneers
                  who share your vision, all of whom offer their unwavering
                  support to revolutionize the way people explore and experience
                  Romania. Your name stands boldly displayed in the digital
                  medium as continual proof of your extensive impact towards
                  building a better future, solidifying your legacy and
                  inspiring new generations
                </span>
              </p>
            </div>
            <div className="ambassadors_imgboxR">
              <img
                alt="image"
                src="/assets/asset%2044.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2044.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2044.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2044.svg"
                className="ambassadors_img"
              />
            </div>
          </section>
        </div>
        <div id="mark" className="ambassadors-container321">
          <section className="ambassadors-thq-mark-elm ambassadors_section">
            <div className="ambassadors_imgboxL">
              <img
                alt="image"
                src="/assets/asset042zz.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset042zz.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset042zz.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset042zz.svg"
                className="ambassadors_img"
              />
            </div>
            <div className="ambassadors-thq-header-elm16 ambassadors_box">
              <div className="ambassadors-container322">
                <div className="ambassadors-thq-header-elm17">
                  <div className="ambassadors-container323">
                    <span className="index_blue">03</span>
                    <div className="ambassadors-container324"></div>
                    <span className="index_black">
                      Your name on a physical monument
                    </span>
                  </div>
                  <div className="ambassadors-container325">
                    <h2 className="ambassadors_word">Mark</h2>
                    <h2 className="ambassadors-thq-heading-elm22 ambassadors_heading">
                      <span className="ambassadors-text1373">
                        your name as legacy
                      </span>
                      <br></br>
                      <span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </h2>
                  </div>
                </div>
                <p className="ambassadors-thq-caption-elm36 ambassadors_text">
                  on the Maecenas Plaque, forever etched in stone on a monument
                  of profound significance
                </p>
              </div>
              <p className="ambassadors-thq-caption-elm37 paragraph">
                <span>Withstand the passage of time by having your name </span>
                <span>
                  forever grace the enduring front of a prominent physical
                  monument, constructed in a specific geolocation that best
                  symbolizes the grand scale of our mission. The Maecenas Plaque
                  contains your engraved name and is a testament to the
                  remarkable individuals who empower Romanian tourism. As we
                  celebrate the names of our ancestors today, firmly placed on
                  ageless pedestals, we pave the way for a future that echoes
                  your own legacy for those to come.
                </span>
              </p>
            </div>
            <a href="#claim">
              <AmbassadorsbtnR
                imageSrc="/assets/asset%2045.svg"
                imageSrc1="/assets/asset%2045.svg"
                imageSrc11="/assets/asset%2045.svg"
                rootClassName="ambassadorsbtn-rroot-class-name"
                className="ambassadors-component34"
              ></AmbassadorsbtnR>
            </a>
          </section>
        </div>
        <div id="claim" className="ambassadors-container326">
          <section className="ambassadors-thq-claim-elm ambassadors_section">
            <a href="#elevate">
              <AmbassadorsbtnL
                imageSrc="/assets/asset043zy.svg"
                imageSrc1="/assets/asset043zy.svg"
                imageSrc11="/assets/asset043zy.svg"
                rootClassName="ambassadorsbtn-lroot-class-name1"
                className="ambassadors-component35"
              ></AmbassadorsbtnL>
            </a>
            <div className="ambassadors-thq-header-elm18 ambassadors_box">
              <div className="ambassadors-container327">
                <div className="ambassadors-thq-header-elm19">
                  <div className="ambassadors-container328">
                    <span className="index_blue">04</span>
                    <div className="ambassadors-container329"></div>
                    <span className="index_black">
                      A medal crafted by the State Mint
                    </span>
                  </div>
                  <div className="ambassadors-container330">
                    <h2 className="ambassadors_word">Claim</h2>
                    <h2 className="ambassadors-thq-heading-elm24 ambassadors_heading">
                      <span className="ambassadors-text1380">
                        the Most Distinguished Order of Heritage
                      </span>
                      <br></br>
                      <span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </h2>
                  </div>
                </div>
                <p className="ambassadors-thq-caption-elm38 ambassadors_text">
                  a symbol of recognition for exceptional achievement, crafted
                  by the State Mint
                </p>
              </div>
              <p className="ambassadors-thq-caption-elm39 paragraph">
                Display a confident acknowledgement of merit with the
                prestigious medal of distinction forged in the hallowed halls of
                the State Mint. This is an opportunity for you to show the world
                a physical manifestation of your extraordinary contribution as
                an Honorary Tourism Ambassador. The exquisite emblem stands as a
                timeless symbol, reflecting your unwavering dedication to propel
                the @Romania Tourism Initiative forward and commemorating your
                invaluable influence in shaping the country’s new Tourism Brand
              </p>
            </div>
            <div className="ambassadors_imgboxR">
              <img
                alt="image"
                src="/assets/asset%2045.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2045.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2045.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset%2045.svg"
                className="ambassadors_img"
              />
            </div>
          </section>
        </div>
        <div id="elevate" className="ambassadors-container331">
          <section className="ambassadors-thq-elevate-elm ambassadors_section">
            <div className="ambassadors_imgboxL">
              <img
                alt="image"
                src="/assets/asset043zy.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset043zy.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset043zy.svg"
                className="ambassadors_img"
              />
              <img
                alt="image"
                src="/assets/asset043zy.svg"
                className="ambassadors_img"
              />
            </div>
            <div className="ambassadors-thq-header-elm20 ambassadors_box">
              <div className="ambassadors-container332">
                <div className="ambassadors-thq-header-elm21">
                  <div className="ambassadors-container333">
                    <span className="index_blue">05</span>
                    <div className="ambassadors-container334"></div>
                    <span className="index_black">
                      Elite networking opportunities
                    </span>
                  </div>
                  <div className="ambassadors-container335">
                    <h2 className="ambassadors_word">Elevate</h2>
                    <h2 className="ambassadors-thq-heading-elm26 ambassadors_heading">
                      <span className="ambassadors-text1385">
                        your connections
                      </span>
                      <br></br>
                      <span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                    </h2>
                  </div>
                </div>
                <p className="ambassadors-thq-caption-elm40 ambassadors_text">
                  by forging extraordinary bonds within an elite community and
                  take part in new transformative experiences
                </p>
              </div>
              <p className="ambassadors-thq-caption-elm41 paragraph">
                Accelerate the growth of your influence by becoming an integral
                part of a world-class network of professionals, executives and
                self-made entrepreneurs, where like-minded individuals spar
                using ideas, share insights and collaborate to build the
                projects of tomorrow. Attend closed-circuit events tailored to
                foster partnerships and one-of-a-kind experiences, further
                enriching your journey as a key advocate for tourism in Romania
              </p>
            </div>
            <a href="#inspire">
              <AmbassadorsbtnCap
                imageSrc="/assets/asset%2046.svg"
                imageSrc1="/assets/asset%2046.svg"
                imageSrc2="/assets/asset%2046.svg"
                imageSrc11="/assets/asset%2046.svg"
                rootClassName="ambassadorsbtn-caproot-class-name"
                className="ambassadors-component36"
              ></AmbassadorsbtnCap>
            </a>
          </section>
        </div>
      </div>
      <div className="ambassadors-thq-testimonials-elm container_1600">
        <div className="ambassadors-thq-header-elm22">
          <div className="ambassadors-thq-header-elm23">
            <h2 className="ambassadors_word">
              <span>Meet some of our</span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
            <h2 className="ambassadors-thq-heading-elm28 ambassadors_heading">
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="ambassadors-text1392">Ambassadors</span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
          </div>
          <p className="ambassadors_text">
            as they share their perspective on @Romania&apos;s initiative,
            long-term goals and their unique experience as pioneers in tourism
          </p>
        </div>
        <div className="ambassadors-container336">
          <div className="ambassadors-container337">
            <img
              alt="image"
              src="/investor-5.7870fbd5-1500w.png"
              className="ambassadors-image198"
            />
            <div className="ambassadors-container338">
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="ambassadors-icon20"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
              </svg>
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="ambassadors-icon22"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
              </svg>
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="ambassadors-icon24"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
              </svg>
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="ambassadors-icon26"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
              </svg>
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="ambassadors-icon28"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
              </svg>
              <svg
                viewBox="0 0 877.7142857142857 1024"
                className="ambassadors-icon30"
              >
                <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
              </svg>
            </div>
          </div>
          <div className="ambassadors-container339">
            <div className="ambassadors-container340">
              <span className="ambassadors-text1395">Roman Popescovescu</span>
              <span className="ambassadors-text1396">CVO @ Vision Company</span>
            </div>
            <div className="ambassadors-thq-divider-elm58"></div>
            <span className="ambassadors-text1397">
              &quot;Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Phasellus rhoncus vehicula auctor. Pellentesque varius nisi a
              tellus dignissim iaculis.&quot;
            </span>
          </div>
        </div>
      </div>
      <div id="brand" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component37"
            ></Chapters>
          </a>
          <ChaptersActive
            name="Country Brand"
            image="/nav patterns/country%20brand.svg"
            chapter="Chapter 02"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name10"
          ></ChaptersActive>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component39"
            ></Chapters>
          </a>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component40"
            ></Chapters>
          </a>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Paltform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Paltform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component41"
            ></Chapters>
          </a>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component42"
            ></Chapters>
          </a>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component43"
            ></Chapters>
          </a>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component44"
            ></Chapters>
          </a>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container341">
              <div className="ambassadors-container342">
                <span className="index_blue">Chapter 02</span>
                <div className="ambassadors-thq-divider-elm59"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>A new Country Brand</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>Is Romania the place where Vampires were born?</span>
              <br></br>
              <br></br>
              <span>
                Maybe it’s the home of famous athletes like Nadia Comaneci and
                Gheorghe Hagi. Or maybe it’s something to do with a Carpathian
                garden overrun by pickpockets.
              </span>
              <br></br>
              <br></br>
              <span>
                People hear bits and pieces of information about Romania that
                are often lost in translation. This is because Romania lacks a
                clear and cohesive narrative to share with the rest of the
                world. It lacks people with enough courage to become Ambassadors
                and help create a new, compelling Country Brand.
              </span>
              <br></br>
              <br></br>
              <span>
                Not having a Country Brand makes it challenging for potential
                visitors to comprehend the essence and uniqueness of our
                country, leading to a diluted global impact. What’s more, it
                hinders not only Romania’s massive tourism potential, but most
                opportunities for economic and social growth.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/country%20brand.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm13">
              <span className="one-liner">
                Setting in motion a paradigm shift.
              </span>
              <p className="paragraph">
                <span>
                  We&apos;re making a positive change in the way we think not
                  just about tourism, but about how we can improve Romania in
                  its entirety. 
                </span>
                <br></br>
                <br></br>
                <span>
                  A powerful Country Brand is a catalyst for progress, uplifting
                  our nation in every way that matters and renewing hope and
                  pride in the hearts of its residents and those who cherish it
                  from afar. 
                </span>
                <span>
                  In order to lay a strong foundation, we must first define what
                  this new Country Brand is and demonstrate why it’s important
                  for Romania to have one.
                </span>
                <br></br>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm60"></div>
            <div className="ambassadors-container343">
              <span className="paragraph-title">
                What is a good Country Brand?
              </span>
              <p className="paragraph">
                <span>
                  In the ever-evolving global landscape, a good Country Brand
                  stands as a purposeful reflection of Romania’s identity,
                  values, culture, unique offerings and aspirations aimed at
                  shaping the world’s perception of our country.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <span>
                  It is the art of translating our country’s essence into a
                  compelling and truthful story. Going beyond marketing, it’s a
                  powerful tool for sparking curiosity about our nation, turning
                  it into a tangible exchange of value at a global scale.
                </span>
                <br></br>
                <br></br>
                <span>
                  We believe its shape and narrative must be contoured and
                  decided together, as a collective of people; as professionals
                  and creatives who understand the important aspects of a
                  Country Brand and can define Romania&apos;s unique strengths
                  within it.
                </span>
                <br></br>
              </p>
            </div>
            <div className="ambassadors-container344">
              <span className="paragraph-title">Why is it important?</span>
              <p className="paragraph">
                <span>
                  A well-crafted Country Brand positions Romania as an
                  exceptional place to visit, live and invest.
                </span>
                <br></br>
                <br></br>
                <span>
                  It opens doors for economic growth, trade opportunities and
                  foreign ventures, which are vital for our country&apos;s
                  prosperity. It also fosters international partnerships and
                  collaborations, further strengthening Romania&apos;s position
                  on the global stage. For big and small businesses, this has a
                  powerful and positive impact, stimulating tourism and driving
                  higher footfall to local enterprises, hotels, restaurants and
                  cultural sites, leading to increased revenue and job
                  opportunities.
                </span>
                <br></br>
                <br></br>
                <span>
                  A robust Country Brand builds confidence in Romania’s
                  potential, inspiring entrepreneurship and innovation. It
                  attracts global attention and interest, providing businesses
                  and startups with a broader market and more significant access
                  to international networks. By being associated with a
                  successful Country Brand, businesses can leverage the positive
                  perception and trust that comes with it, strengthening their
                  competitive edge and expanding their reach globally.
                </span>
                <br></br>
                <br></br>
                <span>
                  For individuals, creating a meaningful Country Brand is
                  important because it instills a sense of pride and belonging,
                  encouraging them to take an active role in promoting and
                  contributing to our country’s growth. It also creates a
                  favorable environment for talent retention and attraction, as
                  people are drawn to live and work in a country with a positive
                  reputation and promising future.
                </span>
                <br></br>
                <br></br>
                <span>
                  Building a compelling Country Brand gives Romania the
                  opportunity to generate positive perceptions that last beyond
                  a tourist’s visit. With it, we can reclaim our narrative from
                  external influences, allowing us to change international
                  perception, challenge stereotypes and prejudices and foster
                  cross-cultural understanding, which, in turn, nurtures a more
                  inclusive and cohesive society.
                </span>
                <br></br>
                <br></br>
                <span>
                  Our vision for a powerful Country Brand is grounded in a deep
                  understanding of Romania’s potential and the shared commitment
                  to revolutionize our nation’s identity.
                </span>
                <br></br>
                <br></br>
                <span>
                  Having a successful Country Brand is important because it will
                  not only boost our country’s tourism and global visibility,
                  but also set in motion a rippling effect that will improve
                  every sector of our economy and positively impact the lives of
                  everyone in Romania.
                </span>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="mhouse" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component45"
            ></Chapters>
          </a>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/country%20brand.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/country%20brand.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component46"
            ></Chapters>
          </a>
          <ChaptersActive
            name="Media House"
            image="/nav patterns/media%20house.svg"
            chapter="Chapter 03"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name11"
          ></ChaptersActive>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component48"
            ></Chapters>
          </a>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Platform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Platform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component49"
            ></Chapters>
          </a>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component50"
            ></Chapters>
          </a>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component51"
            ></Chapters>
          </a>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component52"
            ></Chapters>
          </a>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container345">
              <div className="ambassadors-container346">
                <span className="index_blue">Chapter 03</span>
                <div className="ambassadors-thq-divider-elm61"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>Media House</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                Can you remember the last time you saw meaningful content aimed
                at promoting Romania that was both authentic and impactful?
              </span>
              <br></br>
              <br></br>
              <span>
                If the answer is yes, you are part of a very small number of
                people who do. If the answer is no, it helps prove the point
                that such content is rarely seen or remembered.
              </span>
              <br></br>
              <br></br>
              <span>
                One of the most concerning issues is the misallocation of funds
                meant to be used to promote Romania. Substantial financial
                resources are being poured into promotional videos that, more
                often than not, fall short of making a significant impact. These
                funds largely originate from governmental budgets, representing
                a sizable chunk of public money. Despite this heavy investment,
                the reach and impact of these promotional materials are far from
                proportional to the resources expended.
              </span>
              <br></br>
              <br></br>
              <span>
                A different problem is that current productions are limited in
                terms of language. Similar to the approach of many other
                countries, content aimed at showcasing Romania as a travel
                destination is predominantly made in English, although
                ironically enough, also in Romanian. While English is
                undoubtedly a global lingua franca, the assumption that it
                suffices for global reach is a misstep. Neglecting non-English
                speaking countries and relying solely on English and Romanian
                content is a missed opportunity to engage with potential
                tourists from regions where these languages are not prevalent.
              </span>
              <br></br>
              <br></br>
              <span>
                Take, for example, countries like Spain, Italy or Japan. While
                they have large populations, English proficiency is relatively
                low, especially outside major cities and in non-urban areas. By
                limiting communication to English and Romanian, we are
                restricting our ability to connect with people from these
                countries who may be eager to explore Romania but face an
                avoidable language barrier.
              </span>
              <br></br>
              <br></br>
              <span>
                In today’s interconnected world of tourism and travel promotion,
                the days where we spend glorious budgets on single promotional
                videos and even more on trying to propagate them are long gone.
                The challenges and opportunities presented by the digital age
                call for a more nuanced and strategic approach to showcasing the
                beauty and allure of Romania to the world. To truly succeed, we
                must pivot towards a solution where resources are allocated
                wisely and content is not just memorable but also authentically
                resonates with diverse audiences. This new era of tourism
                promotion demands innovation, adaptability and a commitment to
                making every promotional effort genuinely impactful through
                fast, high-impact production and organic viral growth.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/media%20house.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm14">
              <span className="one-liner">
                The world’s media landscape is undergoing a significant
                evolution.
              </span>
              <p className="paragraph">
                <span>
                  {' '}
                  With the shift from overly produced, highly scripted tv-style
                  content to the realm of authenticity and personal connection,
                  the means of content delivery are also transforming. Streaming
                  platforms and social media are now the go-to channels for
                  engaging audiences through genuine, relatable narratives.
                </span>
                <br></br>
                <br></br>
                <span>
                  It is within this context that we’re building the Media House,
                  an independent creation engine aimed at harnessing the power
                  of social media to represent an in-depth, authentic view of
                  Romania that crosses language barriers on a global scale.
                </span>
                <br></br>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm62"></div>
            <div className="ambassadors-container347">
              <span className="paragraph-title">
                Independent Creation Engine
              </span>
              <p className="paragraph">
                <span>
                  In order to achieve a highly engaging, original and dynamic
                  format, we first need to have full control over the production
                  process. This means the Media House needs to be a
                  self-sufficient incubator for experimentation and
                  storytelling, ensuring that the creative vision remains
                  uncompromised by third parties. This way, we secure the
                  ability to craft impactful content that offers an authentic
                  and captivating portrayal of Romania&apos;s diverse offerings.
                </span>
                <br></br>
              </p>
            </div>
            <div className="ambassadors-container348">
              <span className="paragraph-title">Faster Iteration</span>
              <p className="paragraph">
                The essence of creating content that is consistently successful
                partially lies in the ability to iterate and refine. Having the
                autonomy needed allows us to speed up the production process
                without compromising quality. This way, we can freely experiment
                with new concepts, test different approaches and respond more
                effectively to audience feedback. Having a fast iteration
                process means we quickly find out what works and what doesn’t,
                allowing us to focus more resources in the right direction.
              </p>
            </div>
            <div className="ambassadors-container349">
              <span className="paragraph-title">Maximizing Value</span>
              <p className="paragraph">
                Handling every step of the creation process in-house gives us
                the capacity to accurately control everything from budget, to
                narrative, creative scope and ultimately the final product. This
                way, content made via the Media House has a much greater
                opportunity to achieve high impact and generate more value using
                less resources.
              </p>
            </div>
            <div className="ambassadors-container350">
              <span className="paragraph-title">
                Engaging an International Audience
              </span>
              <p className="paragraph">
                With the Media House, we efficiently service a large percentage
                of non-English speakers by crafting content that extends across
                multiple languages. This not only allows us to better share
                Romania’s message with specific international audiences, but
                also transcend cultural boundaries and establish new connections
                with a completely untapped crowd.
              </p>
            </div>
            <div className="ambassadors-container351">
              <span className="paragraph-title">
                Servicing Niched Communities
              </span>
              <p className="paragraph">
                A well-structured Media House gives us the ability to distribute
                our focus and resources strategically with the goal of tailoring
                content that resonates with numerous niche communities. By
                moving away from a one-size-fits-all approach, we engage viewers
                on multiple levels and the journey from screen to reality
                becomes a call for more and more people to embrace their
                passions in Romania, as tourists.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="mhub" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component53"
            ></Chapters>
          </a>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component54"
            ></Chapters>
          </a>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component55"
            ></Chapters>
          </a>
          <ChaptersActive
            name="Media Hub"
            image="/nav patterns/media%20hub.svg"
            chapter="Chapter 04"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name12"
          ></ChaptersActive>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Platform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Platform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component57"
            ></Chapters>
          </a>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component58"
            ></Chapters>
          </a>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component59"
            ></Chapters>
          </a>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component60"
            ></Chapters>
          </a>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container352">
              <div className="ambassadors-container353">
                <span className="index_blue">Chapter 04</span>
                <div className="ambassadors-thq-divider-elm63"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>Media Hub</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                Romania is brimming with rich cultural heritage, diverse
                landscapes and captivating attractions, but the tourism industry
                faces a critical challenge: the lack of high-impact, authentic
                content that effectively showcases these offerings to a global
                audience. This absence of compelling narratives hinders
                Romania&apos;s ability to attract tourists, capitalize on its
                vast tourism potential and establish itself as a competing
                travel destination.
              </span>
              <br></br>
              <br></br>
              <span>Several factors contribute to this content deficit.</span>
              <br></br>
              <br></br>
              <span>
                Firstly, creators and influencers who possess the talent and
                expertise to produce captivating content often lack the
                financial resources to embark on these endeavors. The costs of
                travel, accommodation, equipment and production often prove to
                be overwhelming, stifling their creative aspirations and
                hindering their ability to share Romania&apos;s offerings with
                the world. Although creators today can easily produce content
                using their phones, a large number of ideas and deliverables
                require dedicated equipment and software that most don’t have
                access to.
              </span>
              <br></br>
              <br></br>
              <span>
                Furthermore, the lack of collaboration and knowledge sharing
                among creators and influencers further impedes the production of
                relevant content. An isolated approach to content creation
                limits the exchange of ideas, best practices and creative
                expertise, resulting in a fragmented and non-cohesive body of
                work. This lack of collaboration stifles innovation and hinders
                the development of a unified brand identity for Romanian
                tourism.
              </span>
              <br></br>
              <br></br>
              <span>
                Currently, there are numerous creators who make relevant content
                as a hobby or as a part-time occupation. A lot of this content
                has the potential to greatly contribute to Romania’s promotion,
                but often remains hidden from the view of a global audience.
                Without a significant monetary component, creative individuals
                with huge potential don’t have a real incentive to pursue such
                endeavors at a professional level or turn them into a career.
              </span>
              <br></br>
              <br></br>
              <span>
                The limited number of professional creators along with
                fragmented collaboration and insufficient access to resources
                hinders Romania’s ability to attract tourists, generate revenue
                and establish itself as a relevant global travel destination.
              </span>
              <br></br>
              <br></br>
              <span>
                What’s certain is that we need to have a proactive approach and
                seek out creators who have the potential to create real value
                for Romania’s tourism promotion. If left passive, we miss out on
                opportunities to build exposure for our country through the
                people who are actually passionate about it; the opportunity to
                have a diverse community of creators and influencers, with
                different valuable voices, skills and ideas that can generate
                impactful content.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/media%20hub.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm15">
              <span className="one-liner">
                A hearth of creative expression, where adventurous minds
                converge and breathe life into stories that resonate across
                borders.
              </span>
              <p className="paragraph">
                <span>
                  The Media Hub stands as a beacon of inspiration, a sanctuary
                  for creators of all kinds.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <span>
                  The mission is clear: to empower visionaries by providing them
                  with the means to craft impactful narratives that showcase
                  Romania as a travel destination. Here, at the crossroads of
                  culture and technology, we not only unlock the potential of
                  storytellers but also ignite a wave of change in tourism
                  promotion that reverberates beyond our nation.
                </span>
                <br></br>
                <br></br>
                <span>
                  With access to vital funds, industry-leading equipment and
                  unwavering support via the Media Hub, creators embark on a
                  journey that sparks transformation and amplifies voices 
                </span>
                <span>
                  that might otherwise remain unheard. It’s an extraordinary
                  voyage driven by collaboration, where we turn ideas into
                  action and empower creators to showcase Romania’s diverse
                  offerings through an authentic lens, to an international
                  audience.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm64"></div>
            <div className="ambassadors-container354">
              <span className="paragraph-title">
                Collaborative Action
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <p className="paragraph">
                At the heart of the Media Hub lies the empowerment of the
                creative spirit through collaboration. The platform fosters a
                vibrant community where creators can find potential partners for
                projects, exchange ideas and learn from each other&apos;s
                expertise. Professionals can contribute their expertise and
                insights to the Media Hub&apos;s knowledge base, building a
                valuable resource for other aspiring creators and enthusiasts
                alike. This knowledge sharing within a collaborative environment
                fosters a culture of continuous learning. It nurtures innovation
                and encourages the production of high-quality content that
                resonates with a wide range of audiences.
              </p>
            </div>
            <div className="ambassadors-container355">
              <span className="paragraph-title">Creative Insights</span>
              <p className="paragraph">
                The Media Hub offers a wealth of information and resources on
                various aspects of content creation, including photography,
                videography, writing and social media marketing. New and
                experienced creators can access workshops and expert advice from
                a dedicated team in order to enhance their skills and stay
                up-to-date with industry trends.
              </p>
            </div>
            <div className="ambassadors-container356">
              <span className="paragraph-title">Fueling Promotion</span>
              <p className="paragraph">
                We recognize the importance of financial support in empowering
                creators to produce high-value content. To that end, the Media
                Hub serves as a crucial tool for influencers and content
                creators to receive funds and overcome logistical hurdles,
                travel expenses and other costs. Creators, liberated from some
                of the financial constraints, can focus their creative energies
                on crafting compelling narratives and producing engaging content
                that resonates with audiences worldwide and brings their visions
                to life.
              </p>
            </div>
            <div className="ambassadors-container357">
              <span className="paragraph-title">Maximizing Impact</span>
              <p className="paragraph">
                The Media Hub’s allocation of dedicated budgets is not a mere
                act of generosity; it is a strategic investment in
                Romania&apos;s global recognition. Although part of these funds
                are offered as creator incentives, we ensure that the great
                majority is directed towards initiatives that align with the
                overall goal of efficiently promoting Romania and have the
                potential to generate a significant return on investment. By
                supporting creators to produce high-impact content, the Media
                Hub effectively amplifies Romania&apos;s voice on the global
                stage, attracting tourists, fostering cultural exchange and
                promoting the country&apos;s offerings.
              </p>
            </div>
            <div className="ambassadors-container358">
              <span className="paragraph-title">
                Engaging International Influencers
              </span>
              <p className="paragraph">
                <span>
                  The Media Hub incentivizes international influencers and
                  content creators to explore and showcase our country to their
                  native audiences.
                </span>
                <br></br>
                <br></br>
                <span>
                  Alongside a monetary incentive and access to a diverse
                  community of fellow creators, they get comprehensive
                  information, detailed travel guides, cultural insights and
                  recommendations for off-the-beaten-path destinations that
                  empower them to navigate Romania effortlessly and help aim
                  their focus towards their creative work. They can make full
                  use of the Media House to captivate the hearts of their native
                  audiences with a unique perspective on Romania’s offerings.
                </span>
                <br></br>
                <br></br>
                <span>
                  By sparking curiosity within already established communities
                  from abroad we have a sure way of converting a percentage of
                  those audiences into first-time and recurrent travelers to
                  Romania.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="platform" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component61"
            ></Chapters>
          </a>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/country%20brand.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/country%20brand.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component62"
            ></Chapters>
          </a>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component63"
            ></Chapters>
          </a>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component64"
            ></Chapters>
          </a>
          <ChaptersActive
            name="The Platform"
            image="/nav patterns/platform.svg"
            chapter="Chapter 05"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name13"
          ></ChaptersActive>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component66"
            ></Chapters>
          </a>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component67"
            ></Chapters>
          </a>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component68"
            ></Chapters>
          </a>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container359">
              <div className="ambassadors-container360">
                <span className="index_blue">Chapter 05</span>
                <div className="ambassadors-thq-divider-elm65"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>01. Tourism Platform</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                The tourism industry in Romania hinders traveler’s ability to
                optimize their travel experiences and prevents businesses from
                reaching their revenue potential.
              </span>
              <br></br>
              <br></br>
              <span>
                For travelers, the sheer abundance of unreliable travel options
                and fragmented information sources make it difficult to make
                informed decisions, often leading to frustration and wasted
                time. The lack of personalized recommendations and limited
                customization and flexibility leaves travelers with generic
                options that rarely align with their interests and needs.
                Moreover, the inefficient booking process spread across various
                providers results in a time-consuming and error-prone
                experience, causing inconvenience and frustration.
              </span>
              <br></br>
              <br></br>
              <span>
                Businesses are forced to navigate a competitive tourism
                landscape while being constrained by the rules and limitations
                of current travel platforms. The limited reach and visibility of
                their unique offerings amidst the vast sea of competitors make
                it difficult to attract and retain guests. Additionally, the
                lack of data-driven insights on traveler preferences and market
                trends hinders businesses&apos; ability to make informed
                decisions that could optimize their offerings.
              </span>
              <br></br>
              <br></br>
              <span>
                The current tourism landscape is ripe for disruption. A
                transformative solution is needed that goes beyond traditional
                approaches to empower both travelers and businesses yearning for
                a more personalized, convenient and reliable experience.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/platform.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm16">
              <span className="one-liner">
                Transcending the limitations of conventional tourism with a
                future-proof solution for travel hypergrowth, driven by AI.
              </span>
              <p className="paragraph">
                <span>
                  We’re building a digital Tourism Platform for Romania, where
                  the power to shape the way we plan, book and travel lies in
                  the hands of every individual. Where travelers regain control
                  of their time by easily choosing bespoke adventures, or
                  putting together fully customizable trips in minutes.
                </span>
                <br></br>
                <br></br>
                <span>
                  Furthermore, it’s a streamlined solution for businesses to
                  harness their full revenue potential, arming them with the
                  tools needed to advertise their unique offerings, captivate
                  guests and foster growth.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm66"></div>
          </div>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container361">
              <div className="ambassadors-container362">
                <span className="index_black2">Chapter 05</span>
                <div className="ambassadors-thq-divider-elm67"></div>
                <span className="index_black2">01.Tourism Platform</span>
              </div>
              <h2 className="sub-heading">
                <span>Users</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                For most travelers and adventurers, the path to a fulfilling and
                seamless journey is often fraught with challenges.
              </span>
              <br className="ambassadors-text1555"></br>
              <br className="ambassadors-text1556"></br>
              <span>
                As people set out to plan their adventures, they end up losing
                an excessive amount of time doing research. The digital
                landscape that’s supposed to make things easier is fragmented
                into sources of unreliable information that are often hard to
                find.
              </span>
              <br></br>
              <br></br>
              <span>
                Editing and changing routes or swapping objectives while
                planning an itinerary often means starting all over again. Hours
                and even days slip by for travelers trying to figure out what
                activities they can undertake while considering budget and time
                constraints. Assembling a complete travel package becomes a
                time-consuming puzzle as they navigate conflicting details,
                incomplete data and unverified recommendations, ultimately
                leading to a sense of frustration.
              </span>
              <br></br>
              <br></br>
              <span>
                The absence of personalized guidance and real-time assistance in
                curating travel plans adds an element of trial and error,
                leaving travelers at the mercy of chance rather than informed
                decision-making. This uncertainty often results in superficial
                itineraries and subpar travel experiences.
              </span>
              <br className="ambassadors-text1564"></br>
              <br className="ambassadors-text1565"></br>
              <span>
                Numerous exciting destinations in Romania don’t have an online
                presence and information about them is scarce. Without a
                streamlined solution that can intuitively recommend offerings
                that lie beyond the frequently-walked paths, travelers are
                denied access to a wealth of experiences that would potentially
                make lasting positive impressions and encourage them to make
                future visits.
              </span>
              <br className="ambassadors-text1567"></br>
              <br className="ambassadors-text1568"></br>
              <span>
                Most travel platforms today are optimized to drive traffic and
                maximize their own revenue when making recommendations, without
                considering the user’s travel experience. There is no smart
                solution that can efficiently recommend interesting events
                throughout the country, restaurants with authentic food or
                international cuisines, reliable peer-reviewed accommodations,
                affordable transportation options and cultural highlights based
                on user preferences and guest satisfaction.
              </span>
              <br className="ambassadors-text1570"></br>
              <br className="ambassadors-text1571"></br>
              <span>
                The ready-to-use packages found on vacation websites and
                recommendations put together by agencies are far from an ideal
                travel experience. They’re merely standardized, controlled
                products made to maximize business profit at the detriment of
                travelers. You stay in the same hotels as everyone else, you
                visit what everyone else visits and you travel the same routes
                as the people before you. In essence, you see less and pay more.
              </span>
              <br className="ambassadors-text1573"></br>
              <br className="ambassadors-text1574"></br>
              <span>
                The journey towards a truly personalized, memorable adventure is
                hindered not by a lack of enthusiasm, but by the absence of a
                cohesive and user-centric solution that empowers travelers to
                navigate our country&apos;s offerings with confidence, ease and
                excitement.
              </span>
            </p>
            <div className="ambassadors-thq-symbol-elm14">
              <img
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="ambassadors-image203"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm17">
              <span className="one-liner">
                Bypassing the outdated cookie-cutter tours of traditional
                platforms by building a digital solution for easily crafting
                travel experiences.
              </span>
              <p className="paragraph">
                <span>
                  A travel platform driven by traveler satisfaction. One that
                  empowers users to regain control of their time by putting
                  together entire trips in minutes with the help of AI.
                </span>
                <br></br>
                <br></br>
                <span>
                  Travelers using our platform are able to focus on what’s
                  important – crafting their ideal travel experience. With
                  minimal user input, the platform’s AI offers comprehensive
                  travel packages that align with their interests, while
                  accounting for budget and time constraints. Users are able to
                  customize their experience on-the-fly. They can swap out
                  accommodations, tweak transportation arrangements, add or
                  subtract destinations and even extend or shorten the duration
                  of their trip. For instance, they can transform a 5-day
                  exploration into a leisurely 7-day escapade, then decide on a
                  more compact 3-day adventure - and with each change, receive
                  an updated, optimized itinerary.
                </span>
                <br></br>
                <br></br>
                <span>
                  The travel platform also makes accurate recommendations and
                  suggests alternatives based on a user’s travel history. With
                  each new completed journey, the AI understands users’
                  preferences and is able to anticipate their expectations
                  whenever they embark on another adventure.
                </span>
                <br></br>
                <br></br>
                <span>
                  For new users, the interaction with our travel platform is an
                  intuitive plug-and-play experience. By simply engaging in a
                  short interaction with the platform’s AI, travelers are met
                  with bespoke experiences they can use right away and numerous
                  options for building and customizing their travel goals. The
                  opportunities for personalized adventures are endless.
                </span>
                <br></br>
                <br></br>
                <span>
                  In essence, our platform empowers travelers to become the
                  architects of their own journeys, granting them unparalleled
                  control and adaptability. It&apos;s a travel planning
                  experience that remains dynamic, fluid and always responsive
                  to personal whims and evolving priorities.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm68"></div>
            <div className="ambassadors-container363">
              <span className="paragraph-title">
                Enhancing the User Experience
              </span>
              <p className="paragraph">
                <span>
                  With an open-ended canvas at their disposal, users on our
                  platform can craft an unlimited number of experiences that
                  align with their interests.
                </span>
                <br></br>
                <br></br>
                <span>
                  It all begins with a simple choice – their travel goal.
                </span>
                <br></br>
                <br></br>
                <span>
                  Whether it’s a desire to discover Romania’s picturesque
                  countryside, explore multiple cities, take part in thrilling
                  outdoor escapades, or a combination of all of the above, the
                  choice is theirs. As travelers set their destination and
                  articulate their preferences, the AI responds with multiple
                  tailored suggestions in the form of ready-to-use, fully
                  fledged travel packages. These recommendations are not limited
                  to the primary destinations; rather, they encompass a
                  multitude of nearby establishments and objectives that
                  synergize to elevate their journey.
                </span>
                <br></br>
                <br></br>
                <span>
                  Consider a traveler with a deep-seated passion for cultural
                  immersion. Our platform not only offers insights into local
                  landmarks, museums and historical sites but also extends its
                  reach to cover the traveler’s culinary preferences. It
                  recommends dining options that lie within easy reach, align
                  with the user’s gastronomic interests and harmonize seamlessly
                  with their budgetary constraints.
                </span>
                <br></br>
                <br></br>
                <span>
                  The beauty of AI lies in its ability to seamlessly weave these
                  experiences into a coherent narrative. Travelers can wander
                  the cobblestone streets of Brasov one day, indulge in a
                  refined Romanian dining experience in Bucharest the next and
                  embark on a spontaneous road trip to the enchanting Black Sea
                  coast on the third. The logistical intricacies are efficiently
                  managed by the platform&apos;s AI, ensuring that users have
                  access to an inexhaustible combination of adventures that
                  resonate with their interests.
                </span>
              </p>
            </div>
            <div className="ambassadors-container364">
              <span className="paragraph-title">
                Unveiling the Spectrum of Choice
              </span>
              <p className="paragraph">
                <span>
                  The platform’s customization follows a comprehensive approach
                  – every aspect of the journey can be tailored and users can
                  adjust how much input they wish to have.
                </span>
                <br></br>
                <br></br>
                <span>
                  Time, arguably a traveler’s most precious commodity, is fully
                  under users’ control. They can set the pace of their
                  exploration, dictating the duration of their entire journey
                  or, for instance, specifying how many days they wish to
                  dedicate to visiting a certain city. It goes even further
                  where the logistics of travel are seamlessly adjusted to match
                  their preferences. Whether users opt for shorter travel times
                  or extended scenic routes, the choice is theirs.
                </span>
                <br></br>
                <br></br>
                <span>
                  Users further save time while delving deeper into customizing
                  details of their adventure. For example, they can set a goal
                  to explore a certain number of museums during their stay. The
                  platform’s AI steps in as a trusted advisor, examining the
                  input and determining its feasibility. If ambitions don&apos;t
                  align with what’s achievable, the AI gently suggests
                  adjustments, whether it&apos;s extending the timeline and
                  budget or refining the scope. This saves users hours of
                  researching opening times, travel duration, transportation
                  options and costs, entry fees and numerous other variables
                  they need to account for in order to fit these objectives
                  within their limited stay.
                </span>
                <br></br>
                <br></br>
                <span>
                  Financial control is also essential when planning a trip.
                  That’s why travelers on our platform allocate their budget
                  with precision when needed. Whether it&apos;s defining an
                  overarching budget for the entire trip, setting daily spending
                  limits or specifying budgets for accommodation and dining, our
                  platform ensures travelers are in complete financial command.
                  AI handles the data behind the scenes and makes suggestions
                  that can further save on costs, fill their budget or ignore
                  the financial aspect all-together, if they so choose.
                </span>
                <br></br>
                <br></br>
                <span>
                  Users can also solidify their preferences by locking in
                  options they’re satisfied with. These locked choices serve as
                  anchors in their itinerary, ensuring that even as they
                  experiment and modify other elements, the AI respects their
                  selections and refrains from altering what they have securely
                  chosen.
                </span>
                <br></br>
                <br></br>
                <span>
                  With each step, the AI&apos;s insights guide users toward a
                  finely-tuned itinerary that combines their travel goals with
                  real-world data to provide the best possible travel
                  experience. This freedom of choice ensures that every
                  adventure is not just a vacation, but a true representation of
                  their travel philosophy, where the journey is as much a
                  destination as the places they visit.
                </span>
              </p>
            </div>
            <div className="ambassadors-container365">
              <span className="paragraph-title">Seamless Adaptability</span>
              <p className="paragraph">
                <span>
                  Flexibility is key. While planning, users can customize their
                  journeys on-the-fly responding to personal whims by
                  effortlessly swapping out any element that doesn&apos;t
                  resonate with their current preference. Whether it&apos;s the
                  choice of a cozy boutique hotel over a bustling city center
                  stay, the decision to indulge in a spontaneous cultural
                  festival, or a sudden longing to extend their beachside
                  relaxation, our platform ensures that travelers can tailor
                  their expedition in real-time, with no hassle.
                </span>
                <br></br>
                <br></br>
                <span>
                  This seamless adaptability facilitated by AI represents a
                  quantum leap in travel personalization, empowering users with
                  full autonomy over their explorations. It’s like having a
                  personal travel concierge, ever ready to cater to their
                  evolving needs at a moment’s notice. This not only enhances
                  the journey’s enjoyment but also imbues each adventure with a
                  true reflection of the user&apos;s travel goals.
                </span>
              </p>
            </div>
            <div className="ambassadors-container366">
              <span className="paragraph-title">Smart Review System</span>
              <p className="paragraph">
                <span>
                  The influence of user-generated content, particularly reviews,
                  cannot be overstated. These assessments often wield
                  considerable sway in shaping the choices and opinions of
                  travelers, adding importance to the credibility of such
                  reviews.
                </span>
                <br></br>
                <br></br>
                <span>
                  For this, we’ve developed a system that enhances trust and
                  authenticity. Our approach integrates a validation process
                  that ensures users can only review establishments they have
                  personally experienced. These reviews are intrinsically
                  tethered to real transactions, leaving no room for fabricated
                  or malicious evaluations. Beyond greatly minimizing unreliable
                  appraisals, this process fosters a culture of accountability,
                  where every traveler’s voice holds genuine weight.
                </span>
                <br></br>
                <br></br>
                <span>
                  Our review system operates on a dual axis. Firstly, it
                  assesses establishments against a universal standard for
                  quality and service. This provides users with a broad
                  benchmark for evaluating different businesses. Secondly, and
                  more significantly, reviews are contextualized according to
                  user preference. The platform tailors its recommendations
                  based on an individual’s distinct interests. Therefore, when a
                  user explores an establishment’s reviews, they are presented
                  with feedback from fellow travelers who share similar
                  interests, effectively customizing the review experience.
                </span>
                <br></br>
                <br></br>
                <span>
                  Moreover, we&apos;ve introduced a nuanced review weighting
                  system that takes into account a user&apos;s level of
                  experience and knowledge within specific domains. For
                  instance, when considering restaurant reviews, a user with an
                  extensive history of dining at 200 different restaurants holds
                  a more influential review status than someone who has been to
                  just two restaurants. This ensures that reviews are not just
                  democratized, but also stratified based on the depth of a
                  user&apos;s engagement.
                </span>
                <br></br>
                <br></br>
                <span>
                  This comprehensive approach redefines the travel landscape as
                  a domain founded on trust and reliability. On our platform,
                  reviews go beyond just commentary; they become trusted
                  first-hand insights for travelers. This environment of
                  transparency also propels businesses to continually elevate
                  their services, as positive endorsements become the driving
                  force for sustained improvement.
                </span>
              </p>
            </div>
            <div className="ambassadors-container367">
              <span className="paragraph-title">
                Review Incentives for Users
              </span>
              <p className="paragraph">
                <span>
                  We recognize that sharing one’s experience is a valuable
                  contribution and should be rewarded as such. Users who visit a
                  castle, for instance, and share their reviews enjoy numerous
                  benefits such as free entries or digital postcards. Top
                  reviewers may receive weekend getaways or revel in the delight
                  of exclusive discounts at renowned restaurants. These rewards
                  are some of the tokens of appreciation users can expect for
                  the authentic reviews contributed.
                </span>
                <br></br>
                <br></br>
                <span>
                  By transforming the act of review-writing into an avenue for
                  experiences and rewards, we ignite a virtuous cycle where
                  explorers are motivated to chronicle their journeys. As
                  reviewers paint vivid portraits of their encounters, they
                  enrich the community&apos;s shared knowledge, where every
                  voice matters and their contributions are celebrated.
                </span>
              </p>
            </div>
            <div className="ambassadors-container368">
              <span className="paragraph-title">
                Prioritizing Traveler Satisfaction
              </span>
              <p className="paragraph">
                <span>
                  We understand that travelers who enjoy a fulfilling travel
                  experience become more than just visitors; they serve as
                  passionate advocates. Our platform prioritizes the
                  recommendation of establishments with a high return in guest
                  satisfaction, based on user preference. As such, travelers who
                  enjoy a positive experience become passionate supporters for
                  the hotels, restaurants and other establishments that leave a
                  genuine mark during their stay. This encourages them to share
                  their positive experience with friends and family and
                  effectively drive more footfall to the places they enjoy.
                </span>
                <br></br>
                <br></br>
                <span>
                  When user satisfaction flourishes, a ripple effect ensues.
                  People start to share their positive experience with the
                  people they know. With an increase in word-of-mouth
                  recommendations, businesses begin to see more footfall.
                </span>
                <br></br>
                <br></br>
                <span>
                  On top of improving personal experiences for tourists, this
                  also impacts the growth of Romania’s tourism industry.
                  Satisfied travelers tend to stay longer and spend more,
                  contributing significantly to our nation’s economy, while
                  fueling the upward trajectory of the hospitality sector.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container369">
              <div className="ambassadors-container370">
                <span className="index_black2">Chapter 05</span>
                <div className="ambassadors-thq-divider-elm69"></div>
                <span className="index_black2">01.Tourism Platform</span>
              </div>
              <h2 className="sub-heading">
                <span>Businesses</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                Throughout Romania’s tourism sector, a prevailing challenge
                emerges for businesses - many tourism enterprises find
                themselves lacking the ability and resources to attract visitors
                to their establishments. This is partly due to the way current
                travel platforms work.
              </span>
              <br></br>
              <br></br>
              <span>
                Today, these platforms, which have become an essential gateway
                for travelers, often prioritize their own financial gains when
                recommending businesses to users. They offer greater exposure
                for businesses that pay more. As a result, establishments are
                pressured into an unavoidable necessity - a substantial portion
                of their revenue that may otherwise enhance guest experience is
                sacrificed towards gaining visibility on current travel
                platforms, a move that also slashes their profit margins.
              </span>
              <br></br>
              <br></br>
              <span>
                In an effort to balance the scales, many businesses resort to
                bad practices such as overcharging tourists on weekends while
                minimizing costs. This type of action is also attributed to
                their inability to employ better strategies to drive revenue.
                The lack of knowledge causes this behavior to spread throughout
                the tourism sector and is propped by the misguided notion that
                because everyone’s doing it, they should too. These actions
                subsequently lead to a greatly diminished value for visitors,
                significantly impacting the quality of their experiences and
                overall satisfaction.
              </span>
              <br></br>
              <br></br>
              <span>
                Another issue that gets in the way of driving footfall to
                establishments is characterized by the constrained search tools
                that are prevalent on most platforms. These tools offer limited
                visibility, only presenting specific results for a selected
                accommodation. They often lack the capability to include
                establishments and unexplored options en-route or insights and
                suggestions regarding the destinations travelers intend to
                explore.
              </span>
              <br></br>
              <br></br>
              <span>
                Moreover, affiliating with current travel platforms also means
                that partnered establishments must follow rules that may impede
                their progress. This often involves restrictions on
                collaborating with other platforms, conditions on pricing and
                other constraints that hamper their ability to drive footfall
                and maximize revenue.
              </span>
              <br></br>
              <br></br>
              <span>
                Finally, businesses face a shortage of accurate and validated
                feedback. They are often limited to scouring reviews within the
                platforms they are affiliated with, having few options for
                filtering or efficiently extracting relevant insights. Other
                alternatives involve searching for their own establishments on
                various review platforms; a labor intensive process that yields
                minimal constructive results. Unfortunately, these reviews often
                lack valuable context, the identities of reviewers remain
                obscured and distinguishing between genuine and fake comments
                proves challenging. This ultimately makes most current forms of
                digital feedback an unreliable source for improvement.
              </span>
            </p>
            <div className="ambassadors-thq-symbol-elm15">
              <img
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="ambassadors-image204"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm18">
              <span className="one-liner">
                As the landscape of Romania&apos;s tourism industry evolves, we
                challenge the prevailing norms that have hindered businesses
                from reaching their true potential.
              </span>
              <p className="paragraph">
                <span>
                  Imagine a scenario where establishments have the means to
                  invest in staff training, facility enhancements and guest
                  satisfaction as needed. Where travel is not just a transaction
                  but an exploration where personalized recommendations not only
                  align with geographical locations but also with the
                  ever-changing interests of travelers.
                </span>
                <br></br>
                <br></br>
                <span>
                  The Tourism Platform seeks not only to reshape revenue
                  dynamics but also to empower businesses, both large and small,
                  by providing them with relevant insights. Simultaneously, it
                  envisions a new approach to the discovery of services and
                  offerings, where each interaction between businesses and
                  travelers is profoundly personalized, establishing a
                  meaningful relationship between the two and ultimately
                  enhancing recurring visits.
                </span>
                <br></br>
                <br></br>
                <span>
                  The grander vision is one of interconnectivity. It&apos;s
                  about building an environment where businesses can not only
                  survive but flourish. This means not just popular and visible
                  businesses but the hidden gems, the local cafes with artisanal
                  pastries and the adventure companies specializing in thrilling
                  activities. It&apos;s about delivering unforgettable
                  experiences, and in the process, building an economically
                  vibrant tourism landscape.
                </span>
                <br></br>
                <br></br>
                <span>
                  The Tourism Platform is about more than just data; it&apos;s
                  about insights that empower. It&apos;s about more than
                  financial flexibility; it&apos;s about driving a deeper
                  connection between businesses and travelers. This journey
                  takes us beyond the status quo, offering a glimpse of a future
                  where the possibilities for innovation are boundless; where
                  businesses reclaim control over their growth, redefine guest
                  experiences and forge an uncharted path towards sustainable
                  success.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm70"></div>
            <div className="ambassadors-container371">
              <span className="paragraph-title">Empowering Businesses</span>
              <p className="paragraph">
                <span>
                  We are creating a positive shift in revenue dynamics for
                  businesses in tourism. Establishments using our platform
                  retain nearly all of their earnings and maximize opportunities
                  for new revenue streams, only paying an insignificant amount
                  compared to what current travel platforms charge.
                </span>
                <br></br>
                <br></br>
                <span>
                  This reclaimed revenue isn’t just a numerical advantage; it
                  translates into tangible enhancements that directly impact
                  guest experiences. Businesses armed with increased financial
                  flexibility can strategically invest in various aspects of
                  their operations. They can use their reclaimed funds to
                  enhance staff training, improve their facilities, devise
                  impactful promotional campaigns and fuel overall growth,
                  leading to better, more memorable stays for travelers.
                </span>
                <br></br>
                <br></br>
                <span>
                  Access to additional funds empowers businesses to create a
                  competitive edge by delivering comparable or superior services
                  at more enticing price points. This duality of affordability
                  and improved service compounds business growth and nurtures
                  positive online reviews and word-of-mouth recommendations.
                  This leads to more businesses reaching a point of optimal
                  occupancy and demand, enabling them to strategically adjust
                  their pricing models and further augment their revenue
                  streams. Ultimately, this kind of growth presents further
                  opportunities to expand and even branch out to other related
                  services.
                </span>
              </p>
            </div>
            <div className="ambassadors-container372">
              <span className="paragraph-title">Driving Footfall</span>
              <p className="paragraph">
                <span>
                  We’re employing a dynamic solution that revitalizes the
                  connection between businesses and travelers and significantly
                  boosts the visibility and footfall of a diverse range of
                  enterprises.
                </span>
                <br></br>
                <br></br>
                <span>
                  One of its core principles is an enhanced matchmaking approach
                  that goes beyond generic recommendations. The platform
                  leverages data analysis to curate personalized recommendations
                  of businesses for travelers. By understanding the unique
                  interests and needs of travelers, the platform ensures that
                  the businesses suggested are not just geographically relevant
                  but also aligned with the traveler&apos;s specific desires.
                </span>
                <br></br>
                <br></br>
                <span>
                  Unlike traditional systems that focus solely on predefined
                  search criteria, the Tourism Platform goes the extra mile. It
                  suggests businesses that are en-route to a traveler&apos;s
                  destination, even if these establishments might not typically
                  fall within the traveler&apos;s immediate search spectrum.
                  This not only surprises travelers with delightful discoveries
                  but also opens up new avenues for businesses to attract foot
                  traffic they might not have otherwise received.
                </span>
                <br></br>
                <br></br>
                <span>
                  The platform’s AI also takes into account the unique strengths
                  and offerings of each business, aligning them with travelers’
                  goals. This means that a quaint local café known for its
                  artisanal pastries may be recommended to a traveler with a
                  sweet tooth en-route to an unrelated neighboring destination.
                  The AI knows that an outdoor adventure company specializing in
                  thrilling activities might pique the interest of an
                  adrenaline-seeking traveler who’s on their way to the nearby
                  mountainside and recommend it. By making these intelligent
                  connections, the platform ensures that businesses are
                  suggested for reasons that matter most to the traveler,
                  increasing the likelihood of a visit.
                </span>
                <br></br>
                <br></br>
                <span>
                  The collective impact of these features is a win-win scenario.
                  Travelers experience a more personalized, serendipitous and
                  enjoyable journey, making them more likely to explore and
                  engage with local businesses. Simultaneously, businesses,
                  regardless of their size or location, benefit from increased
                  visibility and a broader customer base. Footfall to businesses
                  experiences a significant uptick as a result of this approach,
                  ensuring that a wide range of establishments thrive, not just
                  the most popular or visible ones.
                </span>
                <br></br>
                <br></br>
                <span>
                  In essence, the Tourism Platform transforms a simple trip into
                  a journey of exploration and discovery while simultaneously
                  driving economic growth for local businesses. By facilitating
                  more meaningful connections with travelers, our platform
                  provides businesses with the exposure and footfall necessary
                  for growth, paving the way for an enriched and economically
                  vibrant tourism landscape.
                </span>
              </p>
            </div>
            <div className="ambassadors-container373">
              <span className="paragraph-title">
                Leveraging Data-driven Opportunities
              </span>
              <p className="paragraph">
                <span>
                  Our platform serves as a conduit for businesses to tap into a
                  wealth of valuable information. Data from guests and potential
                  travelers is accurately interpreted via AI to offer businesses
                  a quick and easy way to understand what they’re doing wrong,
                  what they got right and which opportunities they’ve been
                  missing. Establishments can then pivot their offerings to
                  proactively cater to evolving needs, amplify guest
                  satisfaction and enhance their growth.
                </span>
                <br></br>
                <br></br>
                <span>
                  Businesses can check precisely dated and verified reviews from
                  guests, filter positive or negative feedback and observe
                  patterns of complaints and praises within a set interval of
                  time.
                </span>
                <br></br>
                <br></br>
                <span>
                  We also delve deep into the analytics of travelers. The
                  platform’s AI studies the profiles of visitors and the
                  profiles of potential guests who receive recommendations for
                  certain establishments but – for one reason or another –
                  decide to skip them. By examining common interests, past
                  reviews, complaints and other key insights, the platform’s AI
                  establishes patterns in user behavior and demographics. It
                  then uses that information to provide easy solutions for
                  targeted improvements. This is all packaged into bite-sized,
                  easy to follow observations and guidelines that businesses can
                  quickly apply to enhance business operations.
                </span>
                <br></br>
                <br></br>
                <span>
                  On top of a ready-to-use AI analysis, our platform provides
                  businesses with an extensive resource of raw data, which can
                  be further interpreted by specialized experts, if required.
                </span>
                <br></br>
                <br></br>
                <span>
                  This data-driven methodology goes beyond individual
                  businesses, having the potential to shape a comprehensive
                  industry-wide strategy fueled by insight. As businesses align
                  with the power of data analytics, the industry collectively
                  advances toward a future characterized by growth, innovation
                  and a deepened understanding of traveler preferences and
                  behaviors.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container374">
              <div className="ambassadors-container375">
                <span className="index_blue">Chapter 05</span>
                <div className="ambassadors-thq-divider-elm71"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>02. Tourism Promotion Platform</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                In Romania’s tourism realm, current promotion tactics are
                deficient, uncoordinated attempts that fall short of showcasing
                our country’s diverse offerings to the world.
              </span>
              <br className="ambassadors-text1730"></br>
              <br className="ambassadors-text1731"></br>
              <span>
                The entity responsible for tourism promotion is the Ministry of
                Economy, Entrepreneurship and Tourism, funded primarily through
                government allocations, including taxes and support from the
                European Union. However, the impact of most of their initiatives
                has been close to non-existent, resulting in a less than
                desirable outcome for boosting the country’s tourism.
                Additionally, many smaller-scale tourism boards focus their
                efforts on specific areas or cities and operate with local
                budgets, but are far from the scope of effective tourism
                promotion, often wastefully allocating existing funds.
              </span>
              <br className="ambassadors-text1733"></br>
              <br className="ambassadors-text1734"></br>
              <span>
                Countless individual businesses in tourism face a seemingly
                never ending up-hill battle - they lack knowledge and money.
                Because of this, they’re employing promotional strategies aimed
                at driving footfall to their establishments that are often
                short-lived and inefficient, failing to produce the intended
                results. This self-interest approach and isolated modus operandi
                are beyond the notion of tourism promotion, let alone collective
                action. Before they can think about working with others to
                promote tourism at a larger scale, they need to address their
                inefficient management of current revenue streams and their
                inability to tap into additional ones.
              </span>
              <br className="ambassadors-text1736"></br>
              <br className="ambassadors-text1737"></br>
              <span>
                Going beyond financial challenges, it’s also difficult for
                businesses in the hospitality sector to quickly establish a
                working relationship with influencers and content creators. All
                parties involved face a time-consuming discovery process that
                requires research, extensive email exchanges and weeks or months
                of back-and-forth negotiation, often resulting in a completely
                wasted effort. The lack of an efficient, standardized process
                for establishing communication, creating contracts and
                mitigating conflict contributes greatly to this matter.
              </span>
              <br className="ambassadors-text1739"></br>
              <br className="ambassadors-text1740"></br>
              <span>
                Such limitations present the opportunity for an innovative
                solution to streamline tourism promotion and
                partnership-building, fostering more effective opportunities to
                drive revenue for businesses and individuals and ultimately
                showcase Romania as a vibrant tourist destination.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/platform.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm19">
              <span className="one-liner">
                In a world where tradition and innovation intersect, our vision
                stands as a testament to the power of collective action,
                reshaping the way we act to promote Romania’s tourism.
              </span>
              <p className="paragraph">
                <span>
                  The Tourism Promotion Platform is where collaboration thrives
                  and boundaries blur. Here, businesses, tourism boards,
                  influencers, content creators and individuals unite under a
                  shared mission: to unveil Romania&apos;s offerings to the
                  world.
                </span>
                <br></br>
                <br></br>
                <span>
                  The platform weaves connections effortlessly with the help of
                  AI. Hotels and other tourism businesses discover partners for
                  promotion and content creation, while their future bookings
                  become a novel currency they can exchange for services.
                  Meanwhile, influencers and content creators find a gateway to
                  explore Romania, where free stays, earnings and even entire
                  journeys become attainable with unprecedented ease.
                  Negotiations are done seamlessly through easily implemented,
                  standardized contracts that can further be enhanced according
                  to the needs of everyone involved.
                </span>
                <br></br>
                <br></br>
                <span>
                  We’re offering a tailored plug-and-play experience accompanied
                  by the full power of customization. Embark on a voyage of
                  discovery, innovation and joint action, unlike anything
                  you&apos;ve experienced before.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm72"></div>
          </div>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container376">
              <div className="ambassadors-container377">
                <span className="index_black2">Chapter 05</span>
                <div className="ambassadors-thq-divider-elm73"></div>
                <span className="index_black2">
                  02.Tourism Promotion Platform
                </span>
              </div>
              <h2 className="sub-heading">
                <span>Businesses</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                In today&apos;s fast-paced digital landscape, tourism businesses
                find themselves navigating a complex terrain. They either lack
                the means for effective self-promotion or don’t have the
                necessary resources to make a significant impact at their
                current scale. As the digital realm becomes the primary
                environment for travelers to explore their options, many
                businesses simply can&apos;t keep up, causing them to miss out
                on connecting with potential visitors.
              </span>
              <br></br>
              <br></br>
              <span>
                Most tourism businesses just don’t have the funds for a
                dedicated marketing team or high-impact advertisements. What’s
                more, producing captivating promotional material in-house is a
                skill that many of them lack, leading to campaigns that fall
                flat. They remain stuck in outdated promotional tactics with
                little to no chance of breaking through the digital noise. In
                the off chance they do, businesses are still unable to produce
                consistent results that would actually contribute to their
                growth.
              </span>
              <br></br>
              <br></br>
              <span>
                The concept of collaboration and pooling together resources,
                while it has the potential to solve many of these problems,
                remains largely untapped. Businesses that do attempt regional
                promotions through a grouped effort need months to reach common
                ground, allocate funds and negotiate terms and their limited
                budgets make it nearly impossible to create larger, more
                impactful campaigns. This vision of joint promotion remains a
                slow and cumbersome process that rarely results in meaningful
                cooperation. The result is a drain on resources with little to
                show for the effort, with no real way to measure its
                effectiveness. This means that most individual businesses miss
                out on the synergy and benefits that comes from a unified
                approach, if done right.
              </span>
              <br></br>
              <br></br>
              <span>
                Engaging with influencers or content creators and extracting
                value from them proves to be a discouraging endeavor as well.
                With no way to index a list of potential collaborators or filter
                their services according to their needs, businesses can’t afford
                the time and effort needed for manual discovery. They’re bound
                to wait for influencers and content creators to seek them out.
                This means businesses are limited to engaging creators mostly
                from Romania, with very little chance at reaching foreign
                potential partners, further hindering their promotion options.
              </span>
              <br></br>
              <br></br>
              <span>
                Making matters worse, when businesses do finalize deals with
                creators, they often expect immediate conversion; a faulty
                standpoint caused by a prevalent lack of knowledge and expertise
                regarding tourism promotion and social media. This expectation
                is unrealistic because promotional campaigns, especially those
                involving influencers, require time to propagate and work by
                building a brand image through consistent exposure over a set
                timeline. Influencers can help raise brand awareness and trust
                among their audience, but this doesn&apos;t happen overnight and
                instant results are rare.
              </span>
              <br></br>
              <br></br>
              <span>
                Considering the current operational difficulties and monetary
                challenges, most businesses in tourism are reluctant to even try
                such promotional strategies. This leads to a pressing need for
                an intuitive solution that can handle the intricacies of tourism
                promotion behind the scenes and provide a way to generate extra
                revenue through impactful campaigns; a seamless experience where
                businesses can enjoy the benefits of promotion without the
                traditionally associated financial risks and hassle.
              </span>
            </p>
            <div className="ambassadors-thq-symbol-elm17">
              <img
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="ambassadors-image206"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm20">
              <span className="one-liner">
                In the midst of fragmented strategies and financial constraints,
                our platform unveils a paradigm shift for businesses; a gateway
                to a new era of tourism promotion for businesses.
              </span>
              <p className="paragraph">
                <span>
                  We’ve harnessed the power of innovation within an AI-driven
                  platform that seamlessly connects businesses, tourism boards,
                  content creators, influencers and travelers, setting the stage
                  for a harmonious collaboration that will reshape the way we
                  experience and promote Romania.
                </span>
                <br></br>
                <br></br>
                <span>
                  The remarkable potential of future projected vacancies is
                  transformed into a valuable promotional currency, while a
                  permissionless process reduces hassle and elevates efficiency
                  in promotion. Businesses and other entities are empowered with
                  boundless possibilities of uniting with like-minded partners
                  to amplify their reach and tailored options to communicate and
                  negotiate with others.
                </span>
                <br></br>
                <br></br>
                <span>
                  The platform’s dynamic features help minimize costs and
                  maximize the potential for high-impact promotion, offering
                  businesses a tailored approach according to specific needs and
                  strategy.
                </span>
                <br></br>
                <br></br>
                <span>
                  In a world where success hinges on adaptability and
                  innovation, the Tourism Promotion Platform provides the
                  flexibility required to be competitive in the global market,
                  while offering businesses the keys to unlock the full
                  potential of collaborative action to promote Romania and
                  transform one-time guests into recurring travelers.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm74"></div>
            <div className="ambassadors-container378">
              <span className="paragraph-title">
                Leveraging Future Bookings as Currency
              </span>
              <p className="paragraph">
                <span>
                  In a groundbreaking move that transforms the hospitality
                  industry, the Tourism Promotion Platform empowers businesses
                  to make the most of an often-underutilized resource they
                  already own - their unbooked rooms. These vacant
                  accommodations are reimagined as a new currency, unlocking an
                  innovative pathway for funding effective promotion, content
                  creation, and propagation. This paradigm-shifting approach
                  redefines the possibilities for businesses, enabling them to
                  positively impact their growth, even when faced with budget
                  constraints.
                </span>
                <br></br>
                <br></br>
                <span>
                  In essence, the platform harnesses the potential of rooms that
                  would otherwise remain unbooked and allows businesses to use
                  them to employ influencers and content creators for
                  promotional purposes. This effectively converts a potential
                  loss into a valuable asset. By using this untapped resource,
                  businesses break free from the constraints of traditional
                  advertising budgets. They can establish strategic partnerships
                  that yield high-impact exposure while covering only the
                  minimal costs of room maintenance. Interestingly, this is not
                  limited only to hotels or guest houses; any business that
                  operates with future bookings such as restaurants, tour
                  operators, car rental agencies, theaters and more can leverage
                  this strategy.
                </span>
                <br></br>
                <br></br>
                <span>
                  Furthermore, businesses can allocate this resource
                  dynamically, tailoring it to their current needs and
                  promotional strategies. Hotels, for instance, can allocate
                  more unbooked rooms for content creation during off-peak
                  periods to update their marketing collateral. This valuable
                  content, rich with the beauty of their surroundings and unique
                  offerings, can then be used during the peak tourism season to
                  attract more guests with the help of propagators.
                </span>
                <br></br>
                <br></br>
                <span>
                  The ability to convert future bookings into a valuable
                  promotional currency equips businesses with greater
                  flexibility, enhances their marketing strategies and provides
                  a platform for fruitful collaborations. This unique strength
                  opens new horizons for businesses and helps them establish a
                  more competitive international presence.
                </span>
              </p>
            </div>
            <div className="ambassadors-container379">
              <span className="paragraph-title">
                Permissionless AI Experience vs Hands-on Customization
              </span>
              <p className="paragraph">
                <span>
                  Businesses on our platform streamline their interaction with
                  collaborators through a hands-free, permissionless approach.
                  The platform uses essential details about their available
                  rooms, services and budgets to initiate an immediate
                  connection facilitated by AI which acts as the perfect
                  matchmaker, considering the unique needs of each business.
                  It&apos;s akin to casting a wide net to attract collaborators
                  in a matter of moments. This automated process is designed to
                  offer businesses a completely hassle-free experience.
                </span>
                <br></br>
                <br></br>
                <span>
                  Recognizing the undeniable influence of social media, our
                  platform enables businesses to efficiently partner with
                  influencers who boast relevant followings in order to promote
                  their offerings. These collaborations can exponentially expand
                  a business&apos;s reach by propagating their services to a
                  broader audience.
                </span>
                <br></br>
                <br></br>
                <span>
                  Beyond influencers, the platform also opens doors to
                  collaborations with content creators who lack a massive
                  following, but have the ability to produce high-quality visual
                  content that opens up new dimensions of marketing for
                  businesses through organic reach. By employing their services,
                  hotels, guest houses and other related businesses then own
                  professionally-made content that showcase their offerings and
                  can be used in their own promotional campaigns.
                </span>
                <br></br>
                <br></br>
                <span>
                  The platform&apos;s AI acts as a proficient negotiator between
                  businesses and service providers, seamlessly managing supply
                  and demand between the two. This process combines traditional
                  payments and the offer of free stays, allowing businesses to
                  choose a payment method that aligns with their goals.
                </span>
                <br></br>
                <br></br>
                <span>
                  With a permissionless approach, businesses can trust the
                  platform&apos;s AI to select and connect them with the right
                  influencers or content creators. This targeted approach
                  ensures that businesses receive promotional services or
                  content that align closely with their unique character and
                  objectives. The platform’s AI takes into account each
                  business’s offerings, optimizing deliverables for maximum
                  impact. By eliminating the need for time-consuming manual
                  outreach, businesses benefit from significant time and cost
                  savings. It allows them to focus on their core operations,
                  knowing that the platform handles the collaboration process
                  seamlessly and efficiently.
                </span>
                <br></br>
                <br></br>
                <span>
                  The platform also accommodates a more hands-on, customized
                  approach for those looking for more control. This option
                  allows businesses to engage directly with influencers and
                  content creators, giving them the flexibility to negotiate and
                  fine-tune collaboration terms.
                </span>
                <br></br>
                <br></br>
                <span>
                  This empowers businesses to align their collaborations
                  precisely with their unique needs and expectations. They can
                  propose expanded budgets for specific influencers, offering
                  higher compensation in exchange for more promotional services
                  or offer complimentary stays throughout the influencer’s
                  journey at their establishments for an exclusive deal. Such an
                  offer, for instance, reduces fragmentation in the
                  influencer&apos;s journey and enables businesses to maintain
                  continuity in their promotions. It’s a win-win strategy that
                  not only simplifies the collaboration process but also saves
                  costs for businesses and provides an enticing alternative to
                  money for influencers who value convenience and an enriched
                  travel experience.
                </span>
                <br></br>
                <br></br>
                <span>
                  By connecting businesses with these critical players in the
                  digital promotion landscape, our platform breaks down
                  communication barriers, removes time spent on research and
                  streamlines the collaborative process, ensuring that all
                  parties involved benefit significantly from these
                  partnerships.
                </span>
              </p>
            </div>
            <div className="ambassadors-container380">
              <span className="paragraph-title">Limitless Collaboration</span>
              <p className="paragraph">
                <span>
                  In addition to individual promotions, the platform fosters the
                  concept of collaborative endeavors
                </span>
                <span>
                  , allowing businesses, tourism boards and other entities to
                  pool their resources and efforts to achieve a more significant
                  and coordinated impact. This collective approach to promotion
                  is an innovative step towards strengthening the tourism
                  industry, both locally and nationally.
                </span>
                <br></br>
                <br></br>
                <span>
                  At a local level, this means that businesses within a specific
                  geographical area can band together to promote their locality
                  more effectively. For example, several boutique hotels
                  situated on the same historic street in a charming city can
                  share costs and resources and engage influencers to highlight
                  their unique neighborhood and offerings. Such a collective
                  strategy creates a unified voice that benefits all
                  participating businesses, draws more tourists to their area
                  and enhances the overall local experience.
                </span>
                <br></br>
                <br></br>
                <span>
                  These capabilities extend to regional and national
                  collaborations, enabling large-scale promotional campaigns.
                  Tourism boards can tap into this feature, bringing businesses,
                  cultural attractions and accommodation providers together to
                  promote an entire city, region, or even the entire country.
                </span>
                <br></br>
                <br></br>
                <span>
                  Going beyond geographical alliances, this feature extends to
                  businesses and entities that share common interests or operate
                  within the same sector, allowing them to leverage their shared
                  strengths for more impactful promotions. For instance,
                  wineries from various regions can unite to create an extensive
                  campaign promoting Romanian wines as a whole. By working
                  together, they can access a more extensive network of
                  potential customers, raise awareness and elevate the profile
                  of Romanian wine culture, all via one integrated solution.
                </span>
                <br></br>
                <br></br>
                <span>
                  Collaborating with other businesses that share a target
                  audience is a process made seamless by the platform’s AI. For
                  example, museums, local historical tour guides, galleries and
                  historical sites may enter a partnership that can be
                  instrumental in promoting cultural tourism. The platform’s AI
                  instantly recognizes their common ground and proposes
                  collaborations with influencers and content creators within
                  their niche. By joining forces, they can create a compelling
                  campaign that explores the history of a specific region or
                  activities and traditions of a specific period, allowing for a
                  more comprehensive and immersive experience for travelers and,
                  in turn, an increase in footfall to culture related
                  establishments.
                </span>
                <br></br>
                <br></br>
                <span>
                  Furthermore, entities promoting specific tourist destinations
                  in Romania can create powerful cross-sector collaborations.
                  The promotion of a picturesque mountain region could involve
                  cooperation between hotels, restaurants, adventure tour
                  operators, local artisan shops and even wildlife guide
                  agencies. By pooling their resources, these businesses can
                  create inviting promotional campaigns with the help of
                  influencers that showcase the destination to travelers. This
                  increases the overall interest for people to visit the region,
                  stay in hotels, go on adventures, buy artisanal items and use
                  local services.
                </span>
                <br></br>
                <br></br>
                <span>
                  This approach represents a significant departure from the
                  traditional, fragmented promotion model where businesses
                  solely focused on their individual offerings. The tourism
                  promotion platform encourages businesses to look beyond their
                  immediate surroundings and unite under common interests,
                  leveraging the power of collective action to drive tourism
                  promotion on a larger scale, benefiting everyone involved.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container381">
              <div className="ambassadors-container382">
                <span className="index_black2">Chapter 05</span>
                <div className="ambassadors-thq-divider-elm75"></div>
                <span className="index_black2">
                  02.Tourism Promotion Platform
                </span>
              </div>
              <h2 className="sub-heading">
                <span>Influencers &amp; Content Creators</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                Influencers and content creators in search of rewarding
                adventures and lucrative deals in Romania face a slow and
                difficult discovery process that doesn’t guarantee results.
              </span>
              <br></br>
              <br></br>
              <span>
                As they embark on their next journey to explore new lands and
                cultures, creators face a time-consuming digital labyrinth. A
                sea of information, much of it unreliable or incomplete, makes
                researching exciting destinations a daunting task. Many unique
                travel objectives are difficult to find online and some only
                exist through word-of-mouth and local knowledge. Finding
                suitable accommodation is a lottery propped by unreliable
                reviews and questionable photos that rarely reflect reality.
                What’s more, a lot of favorable contemporary or traditional
                culinary experiences are hidden behind mass-market tourist traps
                that provide little to no value to an adventure-hungry
                influencer or content creator. This makes planning a worthwhile
                trip a high-effort endeavor that can span days, weeks or even
                months.
              </span>
              <br></br>
              <br></br>
              <span>
                Individuals looking to create and earn during their trips face
                more hurdles. Establishing contact with potential partners,
                hammering out collaboration details and negotiating terms and
                prices often ensnare influencers and content creators in a web
                of parallel conversations and prolonged timelines. Aligning
                their services or content with the countless, ever-shifting
                requirements of their collaborators becomes a frustrating
                back-and-forth process accompanied by unforeseen delays. A large
                issue, in this case, is that even after months of planning,
                anyone can back out and leave creators with no immediate
                back-up. What’s more, considering alternative destinations and
                adjusting travel objectives while planning their trip heavily
                depends on finding new deals with businesses in their area of
                interest, forcing creators to restart the whole discovery and
                negotiation process. All in all, this leaves influencers and
                content creators who wish to travel and earn in a never-ending
                loop characterized by operational and financial risk.
              </span>
              <br></br>
              <br></br>
              <span>
                The struggles faced by influencers and content creators cast a
                shadow over their creative endeavors, limit their travels and
                inhibit their ability to fully unlock their financial potential.
                A palpable need emerges for a transformative solution, one that
                can simplify and streamline the intricate path of tourism
                promotion and collaboration. One that can ensure that creative
                individuals have the opportunity to realize their ideal travel
                experience and can focus on what they do best – crafting
                compelling content, driving promotional results and delivering
                exceptional value to their partners.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </p>
            <div className="ambassadors-thq-symbol-elm18">
              <img
                alt="image"
                src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                className="ambassadors-image207"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm21">
              <span className="one-liner">
                We’re ushering in a new era of empowerment for influencers and
                content creators, offering the tools they need to promote
                Romania, easily find the right collaborators, achieve their
                travel goals and solidify their income streams.
              </span>
              <p className="paragraph">
                <span>
                  At the heart of this empowerment is an AI-driven experience
                  that simplifies their journey. With minimal input, creators
                  can intuitively sculpt their objectives. Whether they
                  prioritize travel experiences, financial gain, or strike a
                  balance between the two, the platform&apos;s AI ensures that
                  their targets and deliverables are crystal clear. They receive
                  pre-established collaborations that align with their goals,
                  reducing the complexity of deal-making to mere minutes.
                </span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  With the Tourism Promotion Platform, influencers and content
                  creators are no longer bound by the constraints of traditional
                  negotiation. Instead, they gain instant access to a vast pool
                  of opportunities across various regions and an easy way to
                  connect, travel and earn. By enriching their journey, they can
                  turn their personal aspirations into reality while easily and
                  efficiently showcasing Romania’s offerings to the world.
                </span>
                <br></br>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm76"></div>
            <div className="ambassadors-container383">
              <span className="paragraph-title">AI-tailored Journeys</span>
              <p className="paragraph">
                <span>
                  Influencers and content creators using our platform embark on
                  journeys designed to be uniquely tailored to their needs and
                  preferences. They start by defining their goals, indicating
                  the number of days they intend to travel and setting a budget
                  or an earning objective. It’s a remarkably simple and
                  intuitive process, allowing them to fully express their travel
                  ambitions.
                </span>
                <br></br>
                <br></br>
                <span>
                  A content creator, for example, may have a goal of showcasing
                  Romania&apos;s cultural heritage in a week-long trip, seeking
                  free accommodation while maintaining a moderate budget for
                  transport and other small expenses. With these inputs, the
                  platform’s AI steps in, putting together a comprehensive
                  travel itinerary. It begins by suggesting an array of options,
                  spanning from cultural landmarks and local experiences to
                  matching hotels and dining venues they can enjoy for free, in
                  exchange for creating video promotional content. It ensures
                  that each component aligns harmoniously with the
                  creator&apos;s vision, crafting an experience that&apos;s not
                  only memorable but also perfectly aligned with their
                  designated budget or earning expectations.
                </span>
                <br></br>
                <br></br>
                <span>
                  The result? A personalized travel plan with no back-and-forth
                  negotiations. For creators, it means a substantial reduction
                  in the time and effort spent on planning, while the platform
                  takes on the role of a well-informed travel concierge.
                </span>
              </p>
            </div>
            <div className="ambassadors-container384">
              <span className="paragraph-title">
                Instant Access to Collaborations
              </span>
              <p className="paragraph">
                <span>
                  The Tourism Promotion Platform connects influencers and
                  content creators with a dynamic network of businesses eager to
                  collaborate. They can effortlessly explore existing offers or
                  respond to specific requests from businesses seeking their
                  services, without the need for laborious research or outreach
                  efforts; the right opportunities are at their fingertips.
                </span>
                <br></br>
                <br></br>
                <span>
                  For instance, an influencer passionate about adventure tourism
                  can instantly discover a range of collaborations in different
                  areas of interest, from working with an adrenaline-pumping
                  rafting company in the Carpathian Mountains to teaming up with
                  a wilderness survival expert to explore the untamed
                  backcountry of Retezat National Park, showcasing rugged
                  adventures in Romania&apos;s wildest landscapes. These
                  proposals are readily available, saving valuable time and
                  enabling creators to diversify their content and experiences
                  without fearing delays or limiting their earning potential.
                </span>
                <br></br>
                <br></br>
                <span>
                  This transforms the often time-consuming process of finding
                  partnerships into a seamless and efficient experience,
                  empowering influencers and creators to broaden their
                  professional networks and focus on their creative work.
                </span>
              </p>
            </div>
            <div className="ambassadors-container385">
              <span className="paragraph-title">Clear Deliverables</span>
              <p className="paragraph">
                <span>
                  The Tourism Promotion Platform streamlines collaboration
                  between influencers, content creators and businesses by
                  defining precise deliverables. Each collaboration comes with
                  specific expectations, clearly outlining the type of content
                  and number of media products required. Moreover, creators
                  receive a transparent view of their compensation structure,
                  which can encompass earnings, complimentary stays, or
                  immersive experiences.
                </span>
                <br></br>
                <br></br>
                <span>
                  This approach minimizes risk by ensuring that creators are
                  fully aware of their responsibilities and what they will gain
                  from the collaboration even before initiating contact with
                  prospective businesses. This fosters a productive and
                  dependable environment for all parties involved.
                </span>
              </p>
            </div>
            <div className="ambassadors-container386">
              <span className="paragraph-title">Real-time adaptability</span>
              <p className="paragraph">
                <span>
                  While customizing a trip, influencers and content creators can
                  swiftly change their destinations and adjust their monetary
                  goals as they need to. They have the flexibility to edit their
                  travel plans with remarkable ease, adapting to new events or
                  simply shifting their interests as they wish.
                </span>
                <br></br>
                <br></br>
                <span>
                  For instance, a content creator who initially intended to
                  explore the big cities of Romania and create promotional
                  material for local businesses may decide at any point during
                  planning to switch their focus to the picturesque countryside.
                  Instead of going through a lengthy discovery and negotiation
                  process with businesses in this new area of interest, the
                  platform’s AI immediately proposes new collaborations based on
                  the updated destinations and sets up a fully adapted itinerary
                  that meets their preferences. They can proceed to finalize
                  deals or continue to explore other options, receiving updates
                  with each change.
                </span>
                <br></br>
                <br></br>
                <span>
                  This real-time adaptability is a game-changer. Creators can
                  take back their time and seize emerging opportunities with
                  unprecedented speed, ensuring their journeys consistently
                  align with their ever-evolving travel aspirations and
                  financial goals.
                </span>
              </p>
            </div>
            <div className="ambassadors-container387">
              <span className="paragraph-title">Smart Review System</span>
              <p className="paragraph">
                <span>
                  In the digital ecosystem, knowledge is power and the review
                  system empowers creators with the tools they need to make
                  informed decisions. The Tourism Promotion Platform offers an
                  intricate web of reviews and ratings seamlessly managed by AI
                  that offers a personalized view of accomplishments and future
                  opportunities.
                </span>
                <br></br>
                <br></br>
                <span>
                  Influencers and content creators can delve into reviews of
                  businesses, gaining deep insights into their past
                  collaborations with other creators. The platform goes beyond
                  the standard unified approach and presents creators with
                  reviews based on their professional niche. When a travel
                  influencer researches reviews of hotels in a certain area,
                  they get insights from other travel influencers. Content
                  creators who specialize in food photography, for instance, see
                  feedback from other creators operating in the culinary realm.
                  This provides a relevant review experience shared by fellow
                  creators that paints a detailed picture of what to expect,
                  helping individuals select collaborations that are in line
                  with their expectations and objectives.
                </span>
                <br></br>
                <br></br>
                <span>
                  Another fundamental aspect of this system is the meticulous
                  tracking of each collaboration, creating an invaluable
                  database of past deals showcased as easily digestible
                  AI-driven insights. By reviewing their own past experiences
                  through the lens of previous collaborators, creators can
                  refine their strategies moving forward, identifying what
                  worked exceptionally well in one campaign and where there
                  might be room for improvement. This analysis is a powerful
                  tool for personal and professional growth, enabling
                  individuals to harness their full creative and financial
                  potential.
                </span>
                <br></br>
                <br></br>
                <span>
                  The platform analyzes creators across a multifaceted spectrum,
                  recognizing that individual talents shine in different areas.
                  The AI is capable of dissecting these dimensions, pinpointing
                  the areas where a creator excels and matching them with demand
                  for their skills or services. For example, a creator who has
                  extensive experience in nature photography and positive
                  reviews for this particular skill will be high on the
                  recommended list of businesses looking for nature
                  photographers. As a result, influencers and content creators
                  can access opportunities that greatly increase their chances
                  to score high on client satisfaction. The more prominent their
                  review scores, the more appealing they become to businesses
                  seeking top-tier promotional talent.
                </span>
                <br></br>
                <br></br>
                <span>
                  This is a powerful tool for refining strategies and
                  identifying optimal collaborations. It transforms review
                  scores into golden opportunities and streamlines matchmaking,
                  ensuring that talent is efficiently paired with projects that
                  make full use of their skills. For influencers and content
                  creators, the platform’s review system is not just a record of
                  the past; it’s a gateway for growth driven by informed
                  decision-making.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="initiative" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component69"
            ></Chapters>
          </a>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/country%20brand.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/country%20brand.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component70"
            ></Chapters>
          </a>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component71"
            ></Chapters>
          </a>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component72"
            ></Chapters>
          </a>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Platform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Platform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component73"
            ></Chapters>
          </a>
          <ChaptersActive
            name="Origin &amp; Heritage Initiative"
            image="/nav patterns/made%20in%20ro.svg"
            chapter="Chapter 06"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name14"
          ></ChaptersActive>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component75"
            ></Chapters>
          </a>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component76"
            ></Chapters>
          </a>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container388">
              <div className="ambassadors-container389">
                <span className="index_blue">Chapter 06</span>
                <div className="ambassadors-thq-divider-elm77"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>Origin &amp; Heritage Initiative</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                Romania faces significant challenges in asserting its unique
                identity and promoting the authenticity of its products. A
                myriad of goods flood the market without clear indicators of
                their origin, leading to consumer confusion and hindering the
                growth of local industries. The absence of a distinct label that
                can clearly attest the genuine origin of Romanian products and
                form a compelling identity allows for imported items to dominate
                through simple marketing, diminishing the visibility of
                domestically produced goods.
              </span>
              <br></br>
              <br></br>
              <span>
                The lack of a cohesive strategy to showcase Romanian products
                and brands results in missed opportunities for global
                recognition. Our country’s unique strengths and cultural
                significance are often overshadowed in an international context,
                preventing Romanian goods from achieving any kind of large-scale
                acclaim, with some small exceptions that further prove the
                point.
              </span>
              <br></br>
              <br></br>
              <span>
                Additionally, traditional Romanian methods for creating age-old
                products, deeply rooted in the country&apos;s heritage, face the
                risk of fading into obscurity, as there is no formal recognition
                or protection for these culturally significant offerings.
                Romania has experienced the lamentable loss of many traditional
                skills and crafts. Factors such as the aging population, the
                shift towards a service-oriented economy and the associated
                decline of manufacturing have all played pivotal roles in this
                loss. The erosion of these traditional skills represents more
                than just an economic setback; it signifies a loss of cultural
                heritage. As artisans dwindle in numbers, the intrinsic value of
                the traditional aspect of products diminishes, leaving a void in
                our country&apos;s cultural fabric. Beyond the cultural
                implications, this loss also translates into economic
                repercussions, as these unique products often held significant
                commercial value.
              </span>
              <br></br>
              <br></br>
              <span>
                Romania has one of the highest trade deficits within the
                European Union. This essentially means we import more goods and
                services than we export. Such an imbalance signals a reliance on
                foreign products but also accentuates the vulnerability of
                Romania’s economic landscape to external economic pressures.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <br></br>
              <span>
                As a consequence, maintaining a sustainable and resilient
                economy becomes challenging, amplifying the importance of
                initiatives that research, identify and promote Romania’s
                strengths in the form of globally competing products and brands.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/made%20in%20ro.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm22">
              <span className="one-liner">
                We’re creating a certification system designed to ensure the
                authenticity of products originating in Romania.
              </span>
              <p className="paragraph">
                A strategic initiative that not only signifies the origin of
                products but serves as a beacon for consumers, guiding them
                towards choices that amplify our country&apos;s economic growth.
                Beyond national borders, it aspires to cultivate internationally
                recognized identities, leveraging Romania’s unique strengths to
                position it as a competitive player on the global market. It
                further beckons consumers on a journey into Romania&apos;s
                heritage, fostering the appreciation for traditional methods and
                cultural distinctiveness. It’s a multifaceted approach that
                celebrates, preserves and propels products and brands provably
                originating in Romania.
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm78"></div>
            <div className="ambassadors-container390">
              <span className="paragraph-title">Romanian Origin Label</span>
              <p className="paragraph">
                <span>
                  From small-scale vendibles and large-scale mass-produced goods
                  to software and digital assets, this label aims to encompass
                  the diverse range of our nation’s offerings.
                </span>
                <br></br>
                <br></br>
                <span>
                  Empowering consumers with an informed choice, it serves as a
                  dependable guide for products that genuinely represent
                  Romanian origin and maintain a commendable standard of
                  quality. It signifies that not only is the product brand
                  proudly Romanian, but a significant portion of the
                  product&apos;s journey, from cultivation, creation or
                  manufacturing occurs within the country.
                </span>
                <br></br>
                <br></br>
                <span>
                  This assurance is rooted in the commitment to promote
                  locally-made products, support Romanian businesses and
                  ultimately enhance our country’s economy. By adopting this
                  label, producers uphold a promise to consumers—a promise of
                  authenticity and a tangible contribution to Romania&apos;s
                  industrial and cultural landscape.
                </span>
                <br></br>
                <br></br>
                <span>
                  The Romanian Origin Label operates in a manner somewhat
                  comparable to the Eco label or other similar certification
                  marks. Just as the Eco label signals environmentally friendly
                  and healthy choices to consumers, the Romanian Origin Label
                  conveys the notion of authenticity, quality and support for
                  the local economy.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <span>
                  Similar to how consumers often perceive Eco-labeled products
                  as healthier or more environmentally conscious, products
                  carrying the Romanian Origin Label would be seen as
                  representing genuine Romanian heritage and a commitment to
                  maintaining commendable standards of quality. This association
                  fosters a positive perception among consumers, leading them to
                  view these labeled goods as trustworthy and potentially
                  superior in quality compared to non-labeled alternatives.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <span>
                  Much like the Eco label influences consumers to be willing to
                  pay more for products they perceive as healthier or
                  environmentally friendly, the Romanian Origin Label can impact
                  consumer behavior. People may be more inclined to choose
                  products carrying the Romanian Origin Label, even if they come
                  at a slightly higher price, because they see it as an
                  investment in their local economy and a way to preserve and
                  support Romanian craftsmanship, culture and businesses.
                </span>
                <br></br>
                <br></br>
                <span>
                  Moreover, the Romanian Origin Label signifies more than just a
                  mark of provenance; it embodies a strategic initiative aimed
                  at fostering economic growth and sustainability on a national
                  scale. By encouraging consumers to support products carrying
                  this label, we are, in essence, redirecting the flow of
                  financial resources back into the economy. This strategic move
                  is rooted in the understanding that when consumers consciously
                  choose products bearing this label, they are not only
                  investing in the product itself but are also making a
                  deliberate choice to contribute to the economic vitality of
                  their own country. This decision to prioritize local goods
                  over imports becomes a powerful mechanism for retaining
                  capital within the national borders, creating a ripple effect
                  with far-reaching benefits across numerous sectors.
                </span>
              </p>
            </div>
            <div className="ambassadors-container391">
              <span className="paragraph-title">
                Globally Recognized Identity
              </span>
              <p className="paragraph">
                <span>
                  Our aspirations transcend the conventional realms of branding.
                  The ‘Origin &amp; Heritage’ initiative is not solely about
                  affixing a label onto products; it is a visionary pursuit to
                  create iconic brands that resonate with consumers worldwide.
                  We envision a future where products bearing Romanian origin
                  are not just recognized but celebrated for their quality and
                  cultural significance.
                </span>
                <br></br>
                <br></br>
                <span>
                  Much like how renowned global products such as Champagne which
                  has transcended its geographical origin as a wine region of
                  France to become a distinguished product type, we have a
                  strategic objective aimed at elevating the perception of
                  Romanian products to an international standard.
                </span>
                <br></br>
                <br></br>
                <span>
                  One of the key facets of our strategy is to identify and
                  leverage the unique strengths that Romania possesses; ones
                  that have a chance at competing with their existing
                  international counterparts. What we mean by that is that our
                  natural springs may boast mineral water with unparalleled
                  properties, presenting an opportunity to establish a distinct
                  identity in the global market, but may have a hard time
                  competing against global brands such as Danone’s ‘Evian’ and
                  Nestle’s ‘San Pellegrino’. Our goal is to start a
                  collaborative research initiative that identifies the right
                  products and build them into a competing strength. By focusing
                  on the inherent qualities of our resources, we aim to create
                  products that not only meet international standards but set
                  new benchmarks for quality and authenticity.
                </span>
                <br></br>
                <br></br>
                <span>
                  Similar to how Spain’s Jamón ibérico, Italy’s
                  Parmigiano-Reggiano and Japan’s Kobe beef all have a profound
                  economic impact on their respective countries, our initiative
                  aims to harness Romania’s offerings and develop products that
                  reach international recognition and substantially contribute
                  to our country’s economy.
                </span>
                <br></br>
                <br></br>
                <span>
                  The vision extends beyond individual products; it encompasses
                  the cultivation of globally recognizable brands that embody
                  the spirit and values of Romania. These brands will be
                  ambassadors of our nation, representing not just the unique
                  aspects of their respective industries but also showcasing
                  Romania’s strengths in an international context.
                </span>
              </p>
            </div>
            <div className="ambassadors-container392">
              <span className="paragraph-title">
                Traditional Speciality Label
              </span>
              <p className="paragraph">
                <span>
                  This label identifies products that are deeply rooted in
                  Romania&apos;s heritage, made using traditional methods and
                  showcasing our country’s rich culture and history. It
                  highlights the authenticity and uniqueness of these products
                  without being linked to a specific geographical area, ensuring
                  that consumers can enjoy traditional Romanian flavors anywhere
                  in the world while supporting Romanian producers.
                </span>
                <br></br>
                <br></br>
                <span>
                  By embracing this designation, producers pledge to uphold the
                  integrity of their products, maintaining the standards that
                  have defined them for generations. This commitment not only
                  preserves our cultural heritage but also strengthens local
                  economies by supporting the livelihoods of artisans, farmers
                  and small-scale producers.
                </span>
                <br></br>
                <br></br>
                <span>
                  Ultimately, this label is a journey into the heart of
                  Romania&apos;s traditions, an exploration of its diverse
                  regions and a celebration of the enduring creativity and
                  dedication of its people. It&apos;s an invitation to savor the
                  past, experience the present and contribute to a future where
                  the richness of our heritage continues to flourish.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="consultancy" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component77"
            ></Chapters>
          </a>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/country%20brand.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/country%20brand.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component78"
            ></Chapters>
          </a>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component79"
            ></Chapters>
          </a>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component80"
            ></Chapters>
          </a>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Platform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Platform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component81"
            ></Chapters>
          </a>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component82"
            ></Chapters>
          </a>
          <ChaptersActive
            name="Consultancy Service"
            image="/nav patterns/consultancy.svg"
            chapter="Chapter 07"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name15"
          ></ChaptersActive>
          <a href="#education">
            <Chapters
              text="Education Program"
              text1="Chapter 08"
              text3="Education Program"
              text11="Chapter 08"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Education Program"
              imageActive="/nav patterns/education.svg"
              nameActive1="Education Program"
              nameDefault="Education Program"
              imageActive1="/nav patterns/education.svg"
              imageDefault="/nav patterns/education.svg"
              nameDefault1="Education Program"
              chapterActive="Chapter 08"
              imageDefault1="/nav patterns/education.svg"
              chapterActive1="Chapter 08"
              chapterDefault="Chapter 08"
              chapterDefault1="Chapter 08"
              className="ambassadors-component84"
            ></Chapters>
          </a>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container393">
              <div className="ambassadors-container394">
                <span className="index_blue">Chapter 07</span>
                <div className="ambassadors-thq-divider-elm79"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>Consultancy Service</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                There is a considerable lack of expertise that hampers Romania’s
                hospitality industry, resulting in a prevalent deficiency in
                quality and service. Without a guiding solution to help
                research, identify and articulate the necessary steps for
                improvement, the industry as a whole makes little to no
                progress, with the exception of a small number of individual
                establishments that further proves the point.
              </span>
              <br className="ambassadors-text1969"></br>
              <br className="ambassadors-text1970"></br>
              <span>
                For hotels and related businesses following an international
                rating system, the price guests pay rarely reflects the quality
                of the offerings when compared to their global counterparts.
                This is the result of a lack of affordable and competent counsel
                that can help businesses reach international standards.
              </span>
              <br className="ambassadors-text1972"></br>
              <br className="ambassadors-text1973"></br>
              <span>
                An intuitive solution to this problem would be to employ
                international consultancy services that can help hotels and
                related businesses quickly reach that higher standard of quality
                and service. Unfortunately, such level of expertise is beyond
                the means of most establishments in Romania, especially
                considering that it usually involves an on-going billable
                process. Even if it’s a one-time fee, the industry is in a
                constant evolution and businesses would need to pay these
                services year after year in order to keep up.
              </span>
              <br className="ambassadors-text1975"></br>
              <br className="ambassadors-text1976"></br>
              <span>
                Another approach would be for businesses to train and specialize
                their own staff locally or overseas. This may seem more
                cost-effective in the long run, but for a single business it’s
                still an expensive endeavor that involves years of preparation.
                It’s also accompanied by the risk of not being able to retain
                the staff that now has a myriad of opportunities to work for
                more prestigious establishments and better pay abroad.
              </span>
              <br className="ambassadors-text1978"></br>
              <br className="ambassadors-text1979"></br>
              <span>
                One may say that businesses can simply contract existing, more
                affordable local experts. Looking at the current predicament the
                hospitality industry is in, it’s safe to assume that in most
                cases, this strategy doesn’t produce the desired results.
              </span>
              <br className="ambassadors-text1981"></br>
              <br className="ambassadors-text1982"></br>
              <span>
                For hotels and related businesses presenting ‘traditional’
                offerings, the authentic Romanian experience guests should
                encounter is often an inaccurate interpretation of Romanian
                values and customs. There is a noticeable absence of
                well-defined guidelines and expert insight in defining what
                constitutes traditional Romanian authenticity within the context
                of hotels and related enterprises.
              </span>
              <br className="ambassadors-text1984"></br>
              <br className="ambassadors-text1985"></br>
              <span>
                With this absence, most businesses find themselves struggling to
                communicate our nation&apos;s heritage in a meaningful and
                authentic way. This deficiency makes room for a range of
                interpretations for ‘traditional’ that often miss the mark,
                culminating in a kitschy offering that distorts the profound
                core of Romanian values and cultural identity. This even extends
                to the misappropriation of foreign cultures, a strategy aimed at
                enhancing visitor experiences that leads to further confusion as
                to what ‘traditional Romanian’ actually means.
              </span>
              <br className="ambassadors-text1987"></br>
              <br className="ambassadors-text1988"></br>
              <span>
                Romania&apos;s hospitality industry faces a twofold challenge:
                the affordability of expertise for achieving international
                standards and the need for a clear definition of authentic
                traditional Romanian experiences. A comprehensive, accessible
                solution that addresses these issues is essential for the
                industry&apos;s sustainable growth and positive representation
                of Romania&apos;s cultural identity on the global stage.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/consultancy.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm23">
              <span className="one-liner">
                We are redefining Romania&apos;s standing on the global stage by
                intertwining the threads of hospitality excellence and the
                authentic representation of our rich cultural heritage.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <p className="paragraph">
                <span>
                  At the heart of this visionary pursuit lies an initiative that
                  seeks not only to elevate the standards of the Romanian
                  hospitality industry to international levels but also to
                  harness and celebrate the timeless allure of our traditional
                  cultural identity.
                </span>
                <br></br>
                <br></br>
                <span>
                  This is a pledge to create an immersive and genuine experience
                  for both locals and global travelers. It&apos;s an invitation
                  to explore a Romania where hospitality is elevated to new
                  heights, and tradition seamlessly weaves with quality. We
                  envision a future where our country&apos;s economic
                  development is propelled by a thriving tourism and hospitality
                  industry, rooted in excellence and tradition.
                </span>
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm80"></div>
            <div className="ambassadors-container395">
              <span className="paragraph-title">
                Achieve International Standards
              </span>
              <p className="paragraph">
                <span>
                  We are elevating the Romanian hospitality industry by
                  establishing an in-house resource hub that goes beyond mere
                  compliance and aims to achieve international standards. This
                  hub serves as a dynamic repository, consistently updated to
                  reflect the latest industry changes.
                </span>
                <br></br>
                <br></br>
                <span>
                  It’s a permanent knowledge base used to elevate individual
                  businesses and the hospitality industry as a whole. By
                  training people in both local and international environments
                  to evolve into qualified industry experts, we offer the key
                  insight and proficiency needed for hospitality establishments
                  to grow.
                </span>
                <br></br>
                <br></br>
                <span>
                  Our initiative equips businesses with an efficient mechanism
                  to elevate their standard of service and overall quality. By
                  nurturing a workforce that is well-versed in international
                  best practices, establishments gain a competitive edge in
                  terms of the value they offer and the pricing they set. As a
                  result, this comprehensive approach contributes to increasing
                  their revenue and enhancing their market competitiveness.
                </span>
                <br></br>
                <br></br>
                <span>
                  The ripple effect of our efforts extends beyond the business
                  realm to significantly improve domestic and international
                  tourist experiences. Visitors will be welcomed by
                  establishments adhering to elevated service standards, thereby
                  enhancing the overall appeal of Romania as a tourist
                  destination. This not only increases positive word-of-mouth
                  recommendations, but also ensures repeat visits, positively
                  impacting our country’s tourism industry.
                </span>
                <br></br>
                <br></br>
                <span>
                  In the broader context, this initiative plays a pivotal role
                  in contributing to Romania’s economic development. By raising
                  the bar for hospitality services, our program stimulates
                  growth, attracting both local and international investments.
                  The resultant economic upswing creates a virtuous cycle that
                  benefits numerous sectors, reinforcing Romania’s position as a
                  thriving hub for tourism and hospitality.
                </span>
              </p>
            </div>
            <div className="ambassadors-container396">
              <span className="paragraph-title">
                Harness Traditional Allure
              </span>
              <p className="paragraph">
                <span>
                  Embracing the traditional charm inherent in Romania’s rich
                  culture involves delving into the essence of what defines
                  ‘traditional Romanian’. This exploration extends beyond the
                  purview of any singular perspective and requires a collective
                  effort to encapsulate the multifaceted characteristics that
                  contribute to our nation’s cultural identity. We envision a
                  collaborative endeavor that draws on the expertise of
                  individuals spanning diverse fields, including history,
                  anthropology, architecture, design, art, and gastronomy,
                  alongside the invaluable insights of local communities.
                </span>
                <br></br>
                <br></br>
                <span>
                  We’re cultivating a dynamic space for inquiry, where experts
                  and communities converge to forge the initial contours of a
                  comprehensive definition for ‘traditional Romanian’. This
                  endeavor transcends mere categorization and evolves into a
                  vibrant repository of knowledge accessible to all. Within this
                  redefined ethos of &apos;traditional,&apos; we seek not only
                  to elucidate the historical and cultural roots but also to
                  instill a discernible standard of quality that harmonizes with
                  and enhances this intrinsic identity.
                </span>
                <br></br>
                <br></br>
                <span>
                  Through the collaborative construction of a knowledge base, we
                  aim to delineate what embodies ‘traditional Romanian’ within
                  both classic and contemporary contexts. This nuanced
                  understanding serves as a comprehensive guide for hospitality
                  enterprises, both emerging and established, providing them
                  with a clear roadmap on how to authentically represent
                  Romania&apos;s identity and historical values in the present
                  day. It is within this innovative framework that we aspire to
                  introduce a distinctive blend of tradition and quality,
                  ensuring a seamless coexistence that does not compromise the
                  integrity of current properties and aesthetics.
                </span>
                <br></br>
                <br></br>
                <span>
                  The result is a renewed invitation to travelers—a beckoning
                  towards an immersive and authentic experience that
                  encapsulates the very essence of Romania. By fostering an
                  environment where tradition and quality converge, we strive to
                  create an enticing space where the past and present
                  harmoniously connect, offering a genuine glimpse into the soul
                  of a nation with a legendary history and a vibrant
                  contemporary identity.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="education" className="container_1600">
        <div className="nav">
          <a href="#ambassador">
            <Chapters
              imageSrc="/nav patterns/test.svg"
              imageSrc1="/nav patterns/test.svg"
              imageActive="/nav patterns/ambassadors.svg"
              imageActive1="/nav patterns/ambassadors.svg"
              imageDefault="/nav patterns/ambassadors.svg"
              imageDefault1="/nav patterns/ambassadors.svg"
              className="ambassadors-component85"
            ></Chapters>
          </a>
          <a href="#brand">
            <Chapters
              text="Country Brand"
              text1="Chapter 02"
              text3="Country Brand"
              text11="Chapter 02"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Country Brand"
              imageActive="/nav patterns/country%20brand.svg"
              nameActive1="Country Brand"
              nameDefault="Country Brand"
              imageActive1="/nav patterns/country%20brand.svg"
              imageDefault="/nav patterns/country%20brand.svg"
              nameDefault1="Country Brand"
              chapterActive="Chapter 02"
              imageDefault1="/nav patterns/country%20brand.svg"
              chapterActive1="Chapter 02"
              chapterDefault="Chapter 02"
              chapterDefault1="Chapter 02"
              className="ambassadors-component86"
            ></Chapters>
          </a>
          <a href="#mhouse">
            <Chapters
              text="Media House"
              text1="Chapter 03"
              text3="Media House"
              text11="Chapter 03"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media House"
              imageActive="/nav patterns/media%20house.svg"
              nameActive1="Media House"
              nameDefault="Media House"
              imageActive1="/nav patterns/media%20house.svg"
              imageDefault="/nav patterns/media%20house.svg"
              nameDefault1="Media House"
              chapterActive="Chapter 03"
              imageDefault1="/nav patterns/media%20house.svg"
              chapterActive1="Chapter 03"
              chapterDefault="Chapter 03"
              chapterDefault1="Chapter 03"
              className="ambassadors-component87"
            ></Chapters>
          </a>
          <a href="#mhub">
            <Chapters
              text="Media Hub"
              text1="Chapter 04"
              text3="Media Hub"
              text11="Chapter 04"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Media Hub"
              imageActive="/nav patterns/media%20hub.svg"
              nameActive1="Media Hub"
              nameDefault="Media Hub"
              imageActive1="/nav patterns/media%20hub.svg"
              imageDefault="/nav patterns/media%20hub.svg"
              nameDefault1="Media Hub"
              chapterActive="Chapter 04"
              imageDefault1="/nav patterns/media%20hub.svg"
              chapterActive1="Chapter 04"
              chapterDefault="Chapter 04"
              chapterDefault1="Chapter 04"
              className="ambassadors-component88"
            ></Chapters>
          </a>
          <a href="#platform">
            <Chapters
              text="The Platform"
              text1="Chapter 05"
              text3="The Platform"
              text11="Chapter 05"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="The Platform"
              imageActive="/nav patterns/platform.svg"
              nameActive1="The Platform"
              nameDefault="The Platform"
              imageActive1="/nav patterns/platform.svg"
              imageDefault="/nav patterns/platform.svg"
              nameDefault1="The Platform"
              chapterActive="Chapter 05"
              imageDefault1="/nav patterns/platform.svg"
              chapterActive1="Chapter 05"
              chapterDefault="Chapter 05"
              chapterDefault1="Chapter 05"
              className="ambassadors-component89"
            ></Chapters>
          </a>
          <a href="#initiative">
            <Chapters
              text="Made in Romania"
              text1="Chapter 06"
              text3="Made in Romania"
              text11="Chapter 06"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Origin &amp; Heritage Initiative"
              imageActive="/nav patterns/made%20in%20ro.svg"
              nameActive1="Origin &amp; Heritage Initiative"
              nameDefault="Origin &amp; Heritage Initiative"
              imageActive1="/nav patterns/made%20in%20ro.svg"
              imageDefault="/nav patterns/made%20in%20ro.svg"
              nameDefault1="Origin &amp; Heritage Initiative"
              chapterActive="Chapter 06"
              imageDefault1="/nav patterns/made%20in%20ro.svg"
              chapterActive1="Chapter 06"
              chapterDefault="Chapter 06"
              chapterDefault1="Chapter 06"
              className="ambassadors-component90"
            ></Chapters>
          </a>
          <a href="#consultancy">
            <Chapters
              text="Consultancy Service"
              text1="Chapter 07"
              text3="Consultancy Service"
              text11="Chapter 07"
              imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              imageSrc1="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
              nameActive="Consultancy Service"
              imageActive="/nav patterns/consultancy.svg"
              nameActive1="Consultancy Service"
              nameDefault="Consultancy Service"
              imageActive1="/nav patterns/consultancy.svg"
              imageDefault="/nav patterns/consultancy.svg"
              nameDefault1="Consultancy Service"
              chapterActive="Chapter 07"
              imageDefault1="/nav patterns/consultancy.svg"
              chapterActive1="Chapter 07"
              chapterDefault="Chapter 07"
              chapterDefault1="Chapter 07"
              className="ambassadors-component91"
            ></Chapters>
          </a>
          <ChaptersActive
            name="Education Program"
            image="/nav patterns/education.svg"
            chapter="Chapter 08"
            imageSrc11="/nav patterns/ambassadors.svg"
            rootClassName="chapters-activeroot-class-name16"
          ></ChaptersActive>
        </div>
        <div className="chapter">
          <section className="chapter_left">
            <div className="ambassadors-container397">
              <div className="ambassadors-container398">
                <span className="index_blue">Chapter 08</span>
                <div className="ambassadors-thq-divider-elm81"></div>
                <span className="index_black">08</span>
              </div>
              <h2 className="heading">
                <span>Education Program</span>
                <br></br>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </h2>
            </div>
            <p className="paragraph">
              <span>
                The Romanian hospitality industry is facing a severe shortage of
                skilled workers that reverberates through every facet of its
                operation. This shortage casts a shadow over service quality,
                operational efficiency and, most critically, guest satisfaction.
              </span>
              <br></br>
              <br></br>
              <span>
                The lack of skilled workers has a significant negative impact on
                the front of the house in many establishments. Front-desk staff,
                bartenders and waitstaff play a vital role in creating a
                positive guest experience, however, many hospitality
                establishments are struggling to find qualified workers in these
                roles. This is leading to long lines at check-in, inaccurate
                orders and slow service. In some cases, establishments are even
                forced to close certain areas or reduce their hours of operation
                due to staff shortages.
              </span>
              <br></br>
              <br></br>
              <span>
                The shortage of skilled workers extends its reach to
                housekeeping—a crucial yet understated element of guest
                satisfaction. Housekeeping staff are responsible for cleaning
                and maintaining guest rooms, however, many establishments are
                struggling to find qualified hands in this domain. The sanctity
                of the guest experience is challenged by rooms falling short of
                cleanliness standards and common areas characterized by
                disarray. The interaction with staff, a cornerstone of
                hospitality, occasionally takes a detour into realms of
                rudeness.
              </span>
              <br></br>
              <br></br>
              <span>
                Romania has a long tradition of delicious and diverse cuisine,
                but many restaurants are struggling to find qualified chefs who
                can prepare these dishes to an adequate standard and maintain
                their traditional aspect. This is also particularly true of
                chefs with experience in international cuisine, which is often
                in high demand from tourists. As a result, many restaurants are
                forced to rely on semi-skilled or unskilled workers in the
                kitchen, which can lead to inconsistent food quality and long
                wait times for guests.
              </span>
              <br></br>
              <br></br>
              <span>
                With personnel often being overworked and undertrained, guests
                experience undesirable encounters and numerous other moments of
                dissatisfaction that further damage the already deficient
                reputation of Romania’s hospitality industry.
              </span>
              <br></br>
              <br></br>
              <span>
                This shortage isn’t just a puzzle to be solved; it’s a call to
                action. A rallying cry for the hospitality industry to rise,
                overcome and secure its legacy. As we navigate these challenges,
                we need to build a narrative where a skilled workforce not only
                meets the demands of today, but sets the stage for continuous
                improvement, ensuring the longevity of tourism and hospitality
                in Romania and the continued satisfaction of travelers.
              </span>
            </p>
            <div className="chapter_imgbox">
              <img
                alt="image"
                src="/nav patterns/education.svg"
                className="chapter_img"
              />
            </div>
          </section>
          <div className="chapter_right">
            <div className="ambassadors-thq-intro-elm24">
              <span className="one-liner">
                Our education initiative is driven by a vision to prepare a
                generation of skilled professionals who embody the spirit of
                true Romanian hospitality.
              </span>
              <p className="paragraph">
                A dedicated environment that nurtures talent, encourages
                innovation and stays attuned to the pulse of industry evolution.
                This journey of continuous learning isn&apos;t just about
                personal growth; it&apos;s a dynamic force propelling a more
                robust, competitive and resilient hospitality industry in
                Romania; where knowledge becomes the driving force behind
                individual development and enriched guest experiences.
              </p>
            </div>
            <div className="ambassadors-thq-divider-elm82"></div>
            <div className="ambassadors-container399">
              <span className="ambassadors-text2042 paragraph-title">
                Lorem ipsum dolor sit amet
              </span>
              <p className="paragraph">
                <span>
                  Investing in education and nurturing a well-trained and
                  skilled workforce empowers our country&apos;s hospitality
                  industry to reach a commendable level of quality and service,
                  and in time, grow to a higher standard. By providing
                  comprehensive training and invaluable experiences, we forge a
                  pathway for individuals to not only excel in their careers but
                  to also carry the essence of our cultural heritage and warmth
                  to every interaction with local and international tourists.
                </span>
                <br></br>
                <br></br>
                <span>
                  A cohesive education program can identify and nurture talent
                  within the industry, allowing individuals to discover and
                  specialize in areas that align with their strengths and
                  interests. It also encourages individuals to think critically
                  and innovate within their roles. This can lead to the
                  development of new and creative approaches to guest
                  experiences, services and offerings, ultimately setting
                  establishments apart and creating a more competitive
                  environment.
                </span>
                <br></br>
                <br></br>
                <span>
                  A well-designed program can keep individuals informed about
                  new industry trends, technologies and best practices. This
                  ensures that the workforce remains up-to-date and capable of
                  meeting and even anticipating guest expectations.
                </span>
                <br></br>
                <br></br>
                <span>
                  For businesses, a well-structured education program is an
                  invaluable resource for fostering a skilled workforce and
                  improving revenue. By enrolling their staff, businesses can
                  elevate the level of service and expertise within their
                  establishment, leading to increased guest satisfaction,
                  enhanced reputation and tourist attraction. By professionally
                  training their employees, businesses are offering the
                  opportunity for individuals to advance their careers and
                  receive higher pay within those establishments, in turn
                  leading to higher staff retention.
                </span>
                <br></br>
                <br></br>
                <span>
                  A well-trained and knowledgeable workforce contributes to a
                  positive overall tourism experience. Satisfied guests are more
                  likely to extend their stays, explore additional services and
                  return in the future, thereby boosting tourism revenue.
                </span>
                <br></br>
                <br></br>
                <span>
                  At the heart of our initiative is the belief that knowledge is
                  a catalyst for positive change. As we elevate the capabilities
                  of individuals, we are igniting growth and prosperity for
                  Romania as a country. By fostering a culture of continuous
                  learning, we are building a stronger, more competitive and
                  resilient hospitality industry that will attract a growing
                  number of international visitors and ultimately improve
                  Romania’s economy.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="ambassadors-thq-call-to-action-banner-elm container_1600">
        <Flowambassador3 rootClassName="flowambassador3root-class-name"></Flowambassador3>
      </div>
      <Footerambassadors rootClassName="footerambassadorsroot-class-name"></Footerambassadors>
    </div>
  )
}

export default Ambassadors
